import axios from 'axios';
import Moment from 'moment';
import qs from 'querystring';
import { encryptStringWithPublicKey, encryptStringWithElogPublicKey, } from '../utils/data_encryption';
import { checkIfTokenHasExpired } from './flag_token_expired';
import { store } from '../utils/configureStore';
import history from '../utils/configureRouteHistory';
import { REST_ERROR_CODE } from '../constants'; 

const ROOT_URL = process.env.REACT_APP_API_ROOT_URL;
const APPLAUNCH_URL = process.env.REACT_APP_APPLAUNCH_ROOT_URL

export const GET_VERSIONS = 'GET_VERSIONS';
export const SUBMIT_FLEX_CLAIM_SUCCESS = 'SUBMIT_FLEX_CLAIM_SUCCESS';
export const SUBMIT_FLEX_CLAIM_ERROR = 'SUBMIT_FLEX_CLAIM_ERROR';
export const GET_CLAIMS = 'GET_CLAIMS';
export const GET_CLAIMS_SUCCESS = 'GET_CLAIMS_SUCCESS';
export const GET_CLAIMS_ERROR = 'GET_CLAIMS_ERROR';
// Generic System Error
export const UPDATE_API_ERROR = 'UPDATE_API_ERROR';
// User Account Functions
export const DO_LOGIN_ERROR = 'DO_LOGIN_ERROR';
export const DO_LOGIN_SUCCESS = 'DO_LOGIN_SUCCESS';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';
export const LOGOUT_USER_ERROR = 'LOGOUT_USER_ERROR';
export const DO_RELOGIN_SUCCESS = 'DO_RELOGIN_SUCCESS';
export const GENERATE_LOGIN_EMAIL_OTP_SUCCESS = 'GENERATE_LOGIN_EMAIL_OTP_SUCCESS';
export const GENERATE_LOGIN_EMAIL_OTP_ERROR = 'GENERATE_LOGIN_EMAIL_OTP_ERROR';
export const RESET_VERIFY_LOGIN_EMAIL_OTP = 'RESET_VERIFY_LOGIN_EMAIL_OTP';
export const VERIFY_LOGIN_EMAIL_OTP_REQUEST = 'VERIFY_LOGIN_EMAIL_OTP_REQUEST';
export const VERIFY_LOGIN_EMAIL_OTP_SUCCESS = 'VERIFY_LOGIN_EMAIL_OTP_SUCCESS';
export const VERIFY_LOGIN_EMAIL_OTP_ERROR = 'VERIFY_LOGIN_EMAIL_OTP_ERROR';
export const GET_USER_PROFILE_PHOTO_SUCCESS = 'GET_USER_PROFILE_PHOTO_SUCCESS';
export const GET_USER_PROFILE_PHOTO_ERROR = 'GET_USER_PROFILE_PHOTO_ERROR';
export const GET_CLAIM_PHOTO_SUCCESS = 'GET_CLAIM_PHOTO_SUCCESS';
export const GET_CLAIM_PHOTO_ERROR = 'GET_CLAIM_PHOTO_ERROR';
export const GET_USER_NOTIFICATIONS_SUCCESS = 'GET_USER_NOTIFICATIONS_SUCCESS';
export const GET_USER_NOTIFICATIONS_ERROR = 'GET_USER_NOTIFICATIONS_ERROR';
export const GET_PROFILE_NOTIFICATIONS_SUCCESS = 'GET_PROFILE_NOTIFICATIONS_SUCCESS';
export const GET_PROFILE_NOTIFICATIONS_ERROR = 'GET_PROFILE_NOTIFICATIONS_ERROR';
export const UPDATE_USER_PROFILE_PHOTO_SUCCESS = 'UPDATE_USER_PROFILE_PHOTO_SUCCESS';
export const UPDATE_USER_PROFILE_PHOTO_ERROR = 'UPDATE_USER_PROFILE_PHOTO_ERROR';
export const UPDATE_USER_PROFILE_INFORMATION_SUCCESS = 'UPDATE_USER_PROFILE_INFORMATION_SUCCESS';
export const UPDATE_USER_PROFILE_INFORMATION_ERROR = 'UPDATE_USER_PROFILE_INFORMATION_ERROR';
export const VERIFY_PASSWORD_SUCCESS = 'VERIFY_PASSWORD_SUCCESS';
export const VERIFY_PASSWORD_ERROR = 'VERIFY_PASSWORD_ERROR';
export const UPDATE_USER_CHANGE_NAME_AND_NRIC_SUCCESS = 'UPDATE_USER_CHANGE_NAME_AND_NRIC_SUCCESS';
export const UPDATE_USER_CHANGE_NAME_AND_NRIC_ERROR = 'UPDATE_USER_CHANGE_NAME_AND_NRIC_ERROR';
export const UPDATE_USER_CHANGE_PASSWORD_SUCCESS = 'UPDATE_USER_CHANGE_PASSWORD_SUCCESS';
export const UPDATE_USER_CHANGE_PASSWORD_ERROR = 'UPDATE_USER_CHANGE_PASSWORD_ERROR';
export const UPDATE_USER_GENERATE_CHANGE_EMAIL_OTP_SUCCESS = 'UPDATE_USER_GENERATE_CHANGE_EMAIL_OTP_SUCCESS';
export const UPDATE_USER_GENERATE_CHANGE_EMAIL_OTP_ERROR = 'UPDATE_USER_GENERATE_CHANGE_EMAIL_OTP_ERROR';
export const UPDATE_USER_VERIFY_CHANGE_EMAIL_OTP_SUCCESS = 'UPDATE_USER_VERIFY_CHANGE_EMAIL_OTP_SUCCESS';
export const UPDATE_USER_VERIFY_CHANGE_EMAIL_OTP_ERROR = 'UPDATE_USER_VERIFY_CHANGE_EMAIL_OTP_ERROR';
export const SUBMIT_RESET_PASSWORD_SUCCESS = 'SUBMIT_RESET_PASSWORD_SUCCESS';
export const SUBMIT_RESET_PASSWORD_ERROR = 'SUBMIT_RESET_PASSWORD_ERROR';
export const SUBMIT_REQ_RESET_PASSWORD_ERROR = 'SUBMIT_REQ_RESET_PASSWORD_ERROR';
export const SUBMIT_REQ_RESET_PASSWORD_SUCCESS = 'SUBMIT_REQ_RESET_PASSWORD_SUCCESS';
export const UPDATE_USER_TOKEN_EXPIRED_ERROR = 'UPDATE_USER_TOKEN_EXPIRED_ERROR';
export const SET_REMIND_UPDATE_PASSWORD = 'SET_REMIND_UPDATE_PASSWORD';
export const GET_USER_PROFILE_SUCCESS = 'GET_USER_PROFILE_SUCCESS';
export const GET_USER_PROFILE_ERROR = 'GET_USER_PROFILE_ERROR';
// User Benefit Config Functions
export const GET_USER_BENEFIT_CONFIG_SUCCESS = 'GET_USER_BENEFIT_CONFIG_SUCCESS';
export const GET_USER_BENEFIT_CONFIG_ERROR = 'GET_USER_BENEFIT_CONFIG_ERROR';
export const GET_USER_BENEFIT_PLAN_SUCCESS = 'GET_USER_BENEFIT_PLAN_SUCCESS';
export const GET_USER_BENEFIT_PLAN_ERROR = 'GET_USER_BENEFIT_PLAN_ERROR';
export const GET_USER_CONFIG_BENEFIT_REQUEST = 'GET_USER_CONFIG_BENEFIT_REQUEST';
export const GET_USER_CONFIG_BENEFIT_SUCCESS = 'GET_USER_CONFIG_BENEFIT_SUCCESS';
export const GET_USER_CONFIG_BENEFIT_ERROR = 'GET_USER_CONFIG_BENEFIT_ERROR';
export const CHECK_ECARD_REQUEST = 'CHECK_ECARD_REQUEST';
export const CHECK_ECARD_SUCCESS = 'CHECK_ECARD_SUCCESS';
export const CHECK_ECARD_ERROR = 'CHECK_ECARD_ERROR';
// Claim Records Functions
export const UPDATE_CLAIM_FILTER_OPTIONS = 'UPDATE_CLAIM_FILTER_OPTIONS';
export const UPDATE_VISIT_FILTER_OPTIONS = 'UPDATE_VISIT_FILTER_OPTIONS';
//Chat api
export const CHAT_ERROR = 'CHAT_ERROR';
export const CHAT_SUCCESS = 'CHAT_SUCCESS';
// Inpatient Claim Functions
export const SUBMIT_INPATIENT_CLAIM_SUCCESS = 'SUBMIT_INPATIENT_CLAIM_SUCCESS';
export const SUBMIT_INPATIENT_CLAIM_ERROR = 'SUBMIT_INPATIENT_CLAIM_ERROR';
export const GET_INPATIENT_CLAIM_OPTIONS_SUCCESS = 'GET_INPATIENT_CLAIM_OPTIONS_SUCCESS';
export const GET_INPATIENT_CLAIM_OPTIONS_ERROR = 'GET_INPATIENT_CLAIM_OPTIONS_ERROR';
export const GET_INPATIENT_CLAIM_SUCCESS = 'GET_INPATIENT_CLAIM_SUCCESS';
export const GET_INPATIENT_CLAIM_ERROR = 'GET_INPATIENT_CLAIM_ERROR';
export const DELETE_INPATIENT_CLAIM_SUCCESS = 'DELETE_INPATIENT_CLAIM_SUCCESS';
export const DELETE_INPATIENT_CLAIM_ERROR = 'DELETE_INPATIENT_CLAIM_ERROR';
export const DELETE_INPATIENT_CLAIM_ID_SUCCESS = 'DELETE_INPATIENT_CLAIM_ID_SUCCESS';
export const DELETE_INPATIENT_CLAIM_ID_ERROR = 'DELETE_INPATIENT_CLAIM_ID_ERROR';
export const UPDATE_UNSUBMITTED_INPATIENT_CLAIM_SUCCESS = 'UPDATE_UNSUBMITTED_INPATIENT_CLAIM_SUCCESS';
export const UPDATE_UNSUBMITTED_INPATIENT_CLAIM_ERROR = 'UPDATE_UNSUBMITTED_INPATIENT_CLAIM_ERROR';
export const UPDATE_INPATIENT_CLAIM_SUCCESS = 'UPDATE_INPATIENT_CLAIM_SUCCESS';
export const UPDATE_INPATIENT_CLAIM_ERROR = 'UPDATE_INPATIENT_CLAIM_ERROR';
export const GET_SINGLE_INPATIENT_CLAIM_SUCCESS = 'GET_SINGLE_INPATIENT_CLAIM_SUCCESS';
export const GET_SINGLE_INPATIENT_CLAIM_ERROR = 'GET_SINGLE_INPATIENT_CLAIM_ERROR';
export const GET_SINGLE_INPATIENT_CLAIM_ID_SUCCESS = 'GET_SINGLE_INPATIENT_CLAIM_ID_SUCCESS';
export const GET_SINGLE_INPATIENT_CLAIM_ID_ERROR = 'GET_SINGLE_INPATIENT_CLAIM_ID_ERROR';
export const GET_ALL_INPATIENT_CLAIM_BY_SYSADMIN_LOADING = 'GET_ALL_INPATIENT_CLAIM_BY_SYSADMIN_LOADING';
export const GET_ALL_INPATIENT_CLAIM_BY_SYSADMIN_SUCCESS = 'GET_ALL_INPATIENT_CLAIM_BY_SYSADMIN_SUCCESS';
export const GET_ALL_INPATIENT_CLAIM_BY_SYSADMIN_ERROR = 'GET_ALL_INPATIENT_CLAIM_BY_SYSADMIN_ERROR';
export const GET_DETAIL_INPATIENT_CLAIM_BY_SYSADMIN_LOADING = 'GET_SINGLE_INPATIENT_CLAIM_BY_SYSADMIN_LOADING';
export const GET_DETAIL_INPATIENT_CLAIM_BY_SYSADMIN_SUCCESS = 'GET_SINGLE_INPATIENT_CLAIM_BY_SYSADMIN_SUCCESS';
export const GET_DETAIL_INPATIENT_CLAIM_BY_SYSADMIN_ERROR = 'GET_SINGLE_INPATIENT_CLAIM_BY_SYSADMIN_ERROR';
export const EDIT_INPATIENT_CLAIM_BY_SYSADMIN_LOADING = 'EDIT_INPATIENT_CLAIM_BY_SYSADMIN_LOADING';
export const EDIT_INPATIENT_CLAIM_BY_SYSADMIN_SUCCESS = 'EDIT_INPATIENT_CLAIM_BY_SYSADMIN_SUCCESS';
export const EDIT_INPATIENT_CLAIM_BY_SYSADMIN_ERROR = 'EDIT_INPATIENT_CLAIM_BY_SYSADMIN_ERROR';

// Outpatient Claim Functions
export const SUBMIT_OUTPATIENT_CLAIM_SUCCESS = 'SUBMIT_OUTPATIENT_CLAIM_SUCCESS';
export const SUBMIT_OUTPATIENT_CLAIM_ERROR = 'SUBMIT_OUTPATIENT_CLAIM_ERROR';
export const GET_OUTPATIENT_CLAIM_SUCCESS = 'GET_OUTPATIENT_CLAIM_SUCCESS';
export const GET_OUTPATIENT_CLAIM_ERROR = 'GET_OUTPATIENT_CLAIM_ERROR';
export const DELETE_OUTPATIENT_CLAIM_ERROR = 'DELETE_OUTPATIENT_CLAIM_ERROR';
export const DELETE_OUTPATIENT_CLAIM_SUCCESS = 'DELETE_OUTPATIENT_CLAIM_SUCCESS';
export const DELETE_OUTPATIENT_CLAIM_ID_ERROR = 'DELETE_OUTPATIENT_CLAIM_ID_ERROR';
export const DELETE_OUTPATIENT_CLAIM_ID_SUCCESS = 'DELETE_OUTPATIENT_CLAIM_ID_SUCCESS';
export const UPDATE_OUTPATIENT_CLAIM_SUCCESS = 'UPDATE_OUTPATIENT_CLAIM_SUCCESS';
export const UPDATE_OUTPATIENT_CLAIM_ERROR = 'UPDATE_OUTPATIENT_CLAIM_ERROR';
export const UPDATE_UNSUBMITTED_OUTPATIENT_CLAIM_SUCCESS = 'UPDATE_UNSUBMITTED_OUTPATIENT_CLAIM_SUCCESS';
export const UPDATE_UNSUBMITTED_OUTPATIENT_CLAIM_ERROR = 'UPDATE_UNSUBMITTED_OUTPATIENT_CLAIM_ERROR';
export const GET_SINGLE_OUTPATIENT_CLAIM_SUCCESS = 'GET_SINGLE_OUTPATIENT_CLAIM_SUCCESS';
export const GET_SINGLE_OUTPATIENT_CLAIM_ERROR = 'GET_SINGLE_OUTPATIENT_CLAIM_ERROR';
export const GET_SINGLE_OUTPATIENT_CLAIM_ID_SUCCESS = 'GET_SINGLE_OUTPATIENT_CLAIM_ID_SUCCESS';
export const GET_SINGLE_OUTPATIENT_CLAIM_ID_ERROR = 'GET_SINGLE_OUTPATIENT_CLAIM_ID_ERROR';
export const GET_ALL_OUTPATIENT_CLAIM_BY_SYSADMIN_LOADING = 'GET_ALL_OUTPATIENT_CLAIM_BY_SYSADMIN_LOADING';
export const GET_ALL_OUTPATIENT_CLAIM_BY_SYSADMIN_SUCCESS = 'GET_ALL_OUTPATIENT_CLAIM_BY_SYSADMIN_SUCCESS';
export const GET_ALL_OUTPATIENT_CLAIM_BY_SYSADMIN_ERROR = 'GET_ALL_OUTPATIENT_CLAIM_BY_SYSADMIN_SUCCESS';
export const GET_DETAIL_OUTPATIENT_CLAIM_BY_SYSADMIN_LOADING = 'GET_SINGLE_OUTPATIENT_CLAIM_BY_SYSADMIN_LOADING';
export const GET_DETAIL_OUTPATIENT_CLAIM_BY_SYSADMIN_SUCCESS = 'GET_SINGLE_OUTPATIENT_CLAIM_BY_SYSADMIN_SUCCESS';
export const GET_DETAIL_OUTPATIENT_CLAIM_BY_SYSADMIN_ERROR = 'GET_SINGLE_OUTPATIENT_CLAIM_BY_SYSADMIN_ERROR';
export const EDIT_OUTPATIENT_CLAIM_BY_SYSADMIN_LOADING = 'EDIT_OUTPATIENT_CLAIM_BY_SYSADMIN_LOADING';
export const EDIT_OUTPATIENT_CLAIM_BY_SYSADMIN_SUCCESS = 'EDIT_OUTPATIENT_CLAIM_BY_SYSADMIN_SUCCESS';
export const EDIT_OUTPATIENT_CLAIM_BY_SYSADMIN_ERROR = 'EDIT_OUTPATIENT_CLAIM_BY_SYSADMIN_ERROR';

// Clinic Locator Functions
export const GET_CLINIC_LIST_REQUEST = 'GET_CLINIC_LIST_REQUEST'
export const GET_CLINIC_LIST_SUCCESS = 'GET_CLINIC_LIST_SUCCESS';
export const GET_CLINIC_LIST_ERROR = 'GET_CLINIC_LIST_ERROR';
export const UPDATE_CLINIC_FILTER_OPTIONS = 'UPDATE_CLINIC_FILTER_OPTIONS';
export const UPDATE_SEARCH_CLINIC_VALUE = 'UPDATE_SEARCH_CLINIC_VALUE'
export const GET_SYSADMIN_CLINIC_LIST_ERROR = 'GET_SYSADMIN_CLINIC_LIST_ERROR'
export const UPDATE_CLINIC_SELECTION = 'UPDATE_CLINIC_SELECTION';

// Register Functions
export const REGISTER_VERIFY_IDENTITY_SUCCESS = 'REGISTER_VERIFY_IDENTITY_SUCCESS';
export const REGISTER_VERIFY_IDENTITY_ERROR = 'REGISTER_VERIFY_IDENTITY_ERROR';
export const REGISTER_GENERATE_EMAIL_OTP_SUCCESS = 'REGISTER_GENERATE_EMAIL_OTP_SUCCESS';
export const REGISTER_GENERATE_EMAIL_OTP_ERROR = 'REGISTER_GENERATE_EMAIL_OTP_ERROR';
export const REGISTER_VERIFY_EMAIL_OTP_SUCCESS = 'REGISTER_VERIFY_EMAIL_OTP_SUCCESS';
export const REGISTER_VERIFY_EMAIL_OTP_ERROR = 'REGISTER_VERIFY_EMAIL_OTP_ERROR';
export const REGISTER_ACTIVATE_ACCOUNT_SUCCESS = 'REGISTER_ACTIVATE_ACCOUNT_SUCCESS';
export const REGISTER_ACTIVATE_ACCOUNT_ERROR = 'REGISTER_ACTIVATE_ACCOUNT_ERROR';
// App Config Actions
export const GET_APP_CFG_COUNTRY_CODE_SUCCESS = 'GET_APP_CFG_COUNTRY_CODE_SUCCESS';
export const GET_APP_CFG_COUNTRY_CODE_ERROR = 'GET_APP_CFG_COUNTRY_CODE_ERROR';
export const GET_CLAIM_OPTIONS_SUCCESS = 'GET_CLAIM_OPTIONS_SUCCESS';
export const GET_CLAIM_OPTIONS_ERROR = 'GET_CLAIM_OPTIONS_ERROR';
export const GET_BANK_OPTIONS_SUCCESS = 'GET_BANK_OPTIONS_SUCCESS';
export const GET_BANK_OPTIONS_ERROR = 'GET_BANK_OPTIONS_ERROR';
export const GET_APP_CFG_ELOG_QUESTIONS_SUCCESS = 'GET_APP_CFG_ELOG_QUESTIONS_SUCCESS';
export const GET_APP_CFG_ELOG_QUESTIONS_ERROR = 'GET_APP_CFG_ELOG_QUESTIONS_ERROR';
export const GET_APP_CFG_PUBLIC_KEY_SUCCESS = 'GET_APP_CFG_PUBLIC_KEY_SUCCESS';
export const GET_APP_CFG_PUBLIC_KEY_ERROR = 'GET_APP_CFG_PUBLIC_KEY_ERROR';
export const GET_CLAIM_OPTIONS_REQUEST = 'GET_CLAIM_OPTIONS_REQUEST'

// Authenticator OTP Functions
export const GET_AUTHENTICATOR_OTP_REQUEST = 'GET_AUTHENTICATOR_OTP_REQUEST';
export const GET_AUTHENTICATOR_OTP_SUCCESS = 'GET_AUTHENTICATOR_OTP_SUCCESS';
export const GET_AUTHENTICATOR_OTP_ERROR = 'GET_AUTHENTICATOR_OTP_ERROR';


export const APP_LAUNCH_REQUEST = 'APP_LAUNCH_REQUEST'
export const APP_LAUNCH_SUCCESS = 'APP_LAUNCH_SUCCESS'
export const APP_LAUNCH_FAILURE = 'APP_LAUNCH_FAILURE'
export const DISABLE_COVID_MSG = 'DISABLE_COVID_MSG'
export const ENABLE_COVID_MSG = 'ENABLE_COVID_MSG'

export const SET_COMPANY_CLAIM_OPTIONS_SUCCESS = 'SET_COMPANY_CLAIM_OPTIONS_SUCCESS';
export const SET_CLAIMANT_CLAIM_OPTIONS_SUCCESS = 'SET_CLAIMANT_CLAIM_OPTIONS_SUCCESS';
export const SET_VISIT_DATE_CLAIM_OPTIONS_SUCCESS = 'SET_VISIT_DATE_CLAIM_OPTIONS_SUCCESS';

// System Admin Functions
export const GET_SYSTEM_ADMIN_COMPANIES_SUCCESS = 'GET_SYSTEM_ADMIN_COMPANIES_SUCCESS';
export const GET_SYSTEM_ADMIN_COMPANIES_ERROR = 'GET_SYSTEM_ADMIN_COMPANIES_ERROR';
export const GET_SYSTEM_ADMIN_CLIENTS_SUCCESS = 'GET_SYSTEM_ADMIN_CLIENTS_SUCCESS';
export const GET_SYSTEM_ADMIN_CLIENTS_ERROR = 'GET_SYSTEM_ADMIN_CLIENTS_ERROR';
export const GET_SYSTEM_ADMIN_EXCLUDED_CLINICS_SUCCESS = 'GET_SYSTEM_ADMIN_EXCLUDED_CLINICS_SUCCESS';
export const GET_SYSTEM_ADMIN_EXCLUDED_CLINICS_ERROR = 'GET_SYSTEM_ADMIN_EXCLUDED_CLINICS_ERROR';
export const GET_SYSTEM_ADMIN_USERS_SUCCESS = 'GET_SYSTEM_ADMIN_USERS_SUCCESS';
export const GET_SYSTEM_ADMIN_USERS_ERROR = 'GET_SYSTEM_ADMIN_USERS_ERROR';
export const GET_SYSTEM_ADMIN_USER_DETAIL_SUCCESS = 'GET_SYSTEM_ADMIN_USER_DETAIL_SUCCESS';
export const GET_SYSTEM_ADMIN_USER_DETAIL_ERROR = 'GET_SYSTEM_ADMIN_USER_DETAIL_ERROR';
export const SUBMIT_SYSTEM_ADMIN_CREATE_CLIENT_SUCCESS = 'SUBMIT_SYSTEM_ADMIN_CREATE_CLIENT_SUCCESS';
export const SUBMIT_SYSTEM_ADMIN_CREATE_CLIENT_ERROR = 'SUBMIT_SYSTEM_ADMIN_CREATE_CLIENT_ERROR';
export const SUBMIT_SYSTEM_ADMIN_UPDATE_CLIENT_SUCCESS = 'SUBMIT_SYSTEM_ADMIN_UPDATE_CLIENT_SUCCESS';
export const SUBMIT_SYSTEM_ADMIN_UPDATE_CLIENT_ERROR = 'SUBMIT_SYSTEM_ADMIN_UPDATE_CLIENT_ERROR';
export const SUBMIT_SYSTEM_ADMIN_CREATE_EXCLUDED_CLINIC_SUCCESS = 'SUBMIT_SYSTEM_ADMIN_CREATE_EXCLUDED_CLINIC_SUCCESS';
export const SUBMIT_SYSTEM_ADMIN_CREATE_EXCLUDED_CLINIC_ERROR = 'SUBMIT_SYSTEM_ADMIN_CREATE_EXCLUDED_CLINIC_ERROR';
export const SUBMIT_SYSTEM_ADMIN_DELETE_EXCLUDED_CLINIC_SUCCESS = 'SUBMIT_SYSTEM_ADMIN_DELETE_EXCLUDED_CLINIC_SUCCESS';
export const SUBMIT_SYSTEM_ADMIN_DELETE_EXCLUDED_CLINIC_ERROR = 'SUBMIT_SYSTEM_ADMIN_DELETE_EXCLUDED_CLINIC_ERROR';
export const SUBMIT_SYSTEM_ADMIN_CREATE_USER_SUCCESS = 'SUBMIT_SYSTEM_ADMIN_CREATE_USER_SUCCESS';
export const SUBMIT_SYSTEM_ADMIN_CREATE_USER_ERROR = 'SUBMIT_SYSTEM_ADMIN_CREATE_USER_ERROR';
export const SUBMIT_SYSTEM_ADMIN_UPDATE_USER_SUCCESS = 'SUBMIT_SYSTEM_ADMIN_UPDATE_USER_SUCCESS';
export const SUBMIT_SYSTEM_ADMIN_UPDATE_USER_ERROR = 'SUBMIT_SYSTEM_ADMIN_UPDATE_USER_ERROR';
export const SUBMIT_SYSTEM_ADMIN_UPDATE_USER_DEFAULT_COMPANY_SUCCESS = 'SUBMIT_SYSTEM_ADMIN_UPDATE_USER_DEFAULT_COMPANY_SUCCESS';
export const SUBMIT_SYSTEM_ADMIN_UPDATE_USER_DEFAULT_COMPANY_ERROR = 'SUBMIT_SYSTEM_ADMIN_UPDATE_USER_DEFAULT_COMPANY_ERROR';
export const SUBMIT_SYSTEM_ADMIN_UPLOAD_USERS_SUCCESS = 'SUBMIT_SYSTEM_ADMIN_UPLOAD_USERS_SUCCESS';
export const SUBMIT_SYSTEM_ADMIN_UPLOAD_USERS_ERROR = 'SUBMIT_SYSTEM_ADMIN__UPLOAD_USERS_ERROR';
export const SUBMIT_SYSTEM_ADMIN_USER_BANK_ACCOUNT_SUCCESS = 'SUBMIT_SYSTEM_ADMIN_USER_BANK_ACCOUNT_SUCCESS';
export const SUBMIT_SYSTEM_ADMIN_USER_BANK_ACCOUNT_ERROR = 'SUBMIT_SYSTEM_ADMIN_USER_BANK_ACCOUNT_ERROR';
export const DELETE_PROPOSED_BANK_ACCOUNT_SUCCESS = 'DELETE_PROPOSED_BANK_ACCOUNT_SUCCESS';
export const DELETE_PROPOSED_BANK_ACCOUNT_ERROR = 'DELETE_PROPOSED_BANK_ACCOUNT_ERROR';
export const SUBMIT_SYSTEM_ADMIN_VERIFY_BANK_ACCOUNT_SUCCESS = 'SUBMIT_SYSTEM_ADMIN_VERIFY_BANK_ACCOUNT_SUCCESS';
export const SUBMIT_SYSTEM_ADMIN_VERIFY_BANK_ACCOUNT_ERROR = 'SUBMIT_SYSTEM_ADMIN_VERIFY_BANK_ACCOUNT_ERROR';
export const GET_SYSTEM_ADMIN_HR_CLAIMS_LIST_SUCCESS = 'GET_SYSTEM_ADMIN_HR_CLAIMS_LIST_SUCCESS';
// Article Functions
export const GET_ARTICLES_BANNER_LIST_SUCCESS = 'GET_ARTICLES_BANNER_LIST_SUCCESS';
export const GET_ARTICLES_BANNER_LIST_ERROR = 'GET_ARTICLES_BANNER_LIST_ERROR';
export const GET_ARTICLES_FULL_LIST_SUCCESS = 'GET_ARTICLES_FULL_LIST_SUCCESS';
export const GET_ARTICLES_FULL_LIST_ERROR = 'GET_ARTICLES_FULL_LIST_ERROR';
export const GET_ARTICLES_VIDEOS_FULL_LIST_SUCCESS = 'GET_ARTICLES_VIDEOS_FULL_LIST_SUCCESS';
export const GET_ARTICLES_VIDEOS_FULL_LIST_ERROR = 'GET_ARTICLES_VIDEOS_FULL_LIST_ERROR';
export const GET_ARTICLES_VIDEOS_DETAIL_SUCCESS = 'GET_ARTICLES_VIDEOS_DETAIL_SUCCESS';
export const GET_ARTICLES_VIDEOS_DETAIL_ERROR = 'GET_ARTICLES_VIDEOS_DETAIL_ERROR';
// Elog Functions
export const SUBMIT_ELOG_SUCCESS = 'SUBMIT_ELOG_SUCCESS';
export const SUBMIT_ELOG_ERROR = 'SUBMIT_ELOG_ERROR';
export const GET_ELOG_LIST_SUCCESS = 'GET_ELOG_LIST_SUCCESS';
export const GET_ELOG_LIST_ERROR = 'GET_ELOG_LIST_ERROR';
export const GET_ELOG_PDF_URL_SUCCESS = 'GET_ELOG_PDF_URL_SUCCESS';
export const GET_ELOG_PDF_URL_ERROR = 'GET_ELOG_PDF_URL_ERROR';
// HRAdmin Functions
export const GET_HRADMIN_EMPLOYEE_LIST_SUCCESS = 'GET_HRADMIN_EMPLOYEE_LIST_SUCCESS';
export const GET_HRADMIN_EMPLOYEE_CLAIMS_LIST_SUCCESS = 'GET_HRADMIN_EMPLOYEE_CLAIMS_LIST_SUCCESS';
export const GET_HRADMIN_EMPLOYEE_OUTPATIENT_CLAIM_DATA_SUCCESS = 'GET_HRADMIN_EMPLOYEE_OUTPATIENT_CLAIM_DATA_SUCCESS';
export const GET_HRADMIN_EMPLOYEE_INPATIENT_CLAIM_DATA_SUCCESS = 'GET_HRADMIN_EMPLOYEE_INPATIENT_CLAIM_DATA_SUCCESS';
export const SUBMIT_HRADMIN_EMPLOYEE_HR_CLAIM_DATA_SUCCESS = 'SUBMIT_HRADMIN_EMPLOYEE_HR_CLAIM_DATA_SUCCESS';
export const SUBMIT_HRADMIN_EMPLOYEE_UPDATE_ACCESS_SUCCESS = 'SUBMIT_HRADMIN_EMPLOYEE_UPDATE_ACCESS_SUCCESS';
export const GET_HRADMIN_MHC_INSIGHTS_URL_SUCCESS = 'GET_HRADMIN_MHC_INSIGHTS_URL_SUCCESS';
// App get appLaunch config
export const GET_APPLAUNCH_CONFIG_SUCCESS = 'GET_APPLAUNCH_CONFIG_SUCCESS';
export const GET_APPLAUNCH_CONFIG_ERROR = 'GET_APPLAUNCH_CONFIG_ERROR';
export const RESET_USER_DATA = 'RESET_USER_DATA';
// Rewards
export const GET_REWARDS_CATEGORY_LIST_SUCCESS = 'GET_REWARDS_CATEGORY_LIST_SUCCESS';
export const GET_REWARDS_CATEGORY_LIST_ERROR = 'GET_REWARDS_CATEGORY_LIST_ERROR';
export const GET_REWARDS_LIST_BY_CATEGORY_SUCCESS = 'GET_REWARDS_LIST_BY_CATEGORY_SUCCESS';
export const GET_REWARDS_LIST_BY_CATEGORY_ERROR = 'GET_REWARDS_LIST_BY_CATEGORY_ERROR';
export const GET_REWARDS_DETAILS_SUCCESS = 'GET_REWARDS_DETAILS_SUCCESS';
export const GET_REWARDS_DETAILS_ERROR = 'GET_REWARDS_DETAILS_ERROR';
export const REDEEM_REWARDS_SUCCESS = 'REDEEM_REWARDS_SUCCESS';
export const REDEEM_REWARDS_ERROR = 'REDEEM_REWARDS_ERROR';

// Get UsersHistory
export const GET_AUDIT_USER_REQUEST = "GET_AUDIT_USER_REQUEST";
export const GET_AUDIT_USER_SUCCESS = "GET_AUDIT_USER_SUCCESS";
export const GET_AUDIT_USER_FAILURE = "GET_AUDIT_USER_FAILURE";

export const VIEW_USER_SUCCESS = 'VIEW_USER_SUCCESS';
export const VIEW_USER_ERROR = 'VIEW_USER_ERROR';

// PANEL VISITS V2
export const VISITS_LIST_SUCCESS = 'VISITS_LIST_SUCCESS';
export const VISITS_LIST_ERROR = 'VISITS_LIST_ERROR';
export const VISITS_DETAILS_SUCCESS = 'VISITS_DETAILS_SUCCESS';
export const VISITS_DETAILS_ERROR = 'VISITS_DETAILS_ERROR';

// SETTLEMENT LETTERS
export const GET_SETTLEMENT_LETTER_SUCCESS = 'GET_SETTLEMENT_LETTER_SUCCESS';
export const GET_SETTLEMENT_LETTER_ERROR = 'GET_SETTLEMENT_LETTER_ERROR';

// Add a response interceptor to axios to return the errorMessage from API instead of error object
axios.interceptors.response.use(function(response) {
    return response;
}, function(error) {
    if (error.response && error.response.status && error.response.status === 401) {

        // if response tell expired, locked, suspended, or terminated, reset user data and redirect to login page
        if (error.response.data && (
            error.response.data.errorCode === REST_ERROR_CODE.TOKEN_EXPIRED ||
            error.response.data.errorCode === REST_ERROR_CODE.ACCOUNT_LOCKED ||
            error.response.data.errorCode === REST_ERROR_CODE.ACCOUNT_SUSPENDED ||
            error.response.data.errorCode === REST_ERROR_CODE.ACCOUNT_TERMINATED
            )) {
            if (history.location.pathname !== '/') {
                store.dispatch(resetUserData());
                history.push(`/?redirect=${window.location.pathname}&info=${error.response.data.errorMessage}`);
            }
        }

        return Promise.reject({
            errorCode: 401,
            errorMessage: 'Unauthorized Access or Token has Expired'
        });
    } else if (error.response && error.response.status && error.response.status === 428) {
        store.dispatch(showOTPModal());
        return Promise.reject({
            errorCode: 428,
            errorMessage: 'Your account need verification. If you have any questions, please email us at groupcare@mhcasiagroup.com or call us at +65 63054573.'
        });
    } else {
        if (error.response) {
            return Promise.reject({
                errorCode: error.response.status,
                errorMessage: (error.response.data && error.response.data.errorMessage) ? error.response.data.errorMessage : 'Something went wrong.'
            });
        } else {
            return Promise.reject({
                errorCode: 500,
                errorMessage: error
            });
        }
    }
});

const customFetch = fetch;
global.fetch = (url, config) => {
    return customFetch(url, config).then((response) => {
        if (response.status == 428) {
            store.dispatch(showOTPModal());
            return Promise.reject({
                errorCode: 428,
                errorMessage: 'Your account need verification. If you have any questions, please email us at groupcare@mhcasiagroup.com or call us at +65 63054573.'
            });
        }
        return response
    });
}

export function getVersions() {
    const url = `${ROOT_URL}/versions`;
    const request = axios.get(url);
    return {
        type: GET_VERSIONS,
        payload: request
    };
}

export function getPublicKey() {
    const url = `${ROOT_URL}/publickey`;
    console.log(url)
    const request = axios.get(url);
    return {
        type: GET_APP_CFG_PUBLIC_KEY_SUCCESS,
        payload: request
    };
}

export function getAppConfigCountryCodes() {
    const url = `${ROOT_URL}/countryCodes`;
    const request = axios.get(url);
    return {
        type: GET_APP_CFG_COUNTRY_CODE_SUCCESS,
        payload: request
    };
}

export function doLogoutUser(accessToken) {
    const url = `${ROOT_URL}/users/logout`;
    return axios({
        method: 'post',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        return {
            type: 'USER_LOGOUT',
            payload: null
        };  
    }).catch((error) => {
        return {
            type: LOGOUT_USER_ERROR,
            payload: error
        };
    });
}

export function doLogout() {
    return {
        type: 'USER_LOGOUT',
        payload: null
    };
}
//
// export function doLogin({email, password, birthdate}, callback) {
//
//     // const encryptedNric = encryptStringWithPublicKey(nric);
//     const encryptedPassword = encryptStringWithPublicKey(password);
//
//     const url = `${ROOT_URL}/users/login/v2`;
//     return axios.post(url, {
//         email,
//         password: encryptedPassword,
//         birthdate,
//     }).then((response) => {
//         callback(response.status, null);
//         return {
//             type: DO_LOGIN_SUCCESS,
//             payload: response
//         };
//     }).catch((error) => {
//         console.log(error);
//         callback(null, error);
//         return {
//             type: DO_LOGIN_ERROR,
//             payload: error
//         };
//     });
// }

export function doLoginV3({email, password, captchaResponse}, callback) {

    // const encryptedNric = encryptStringWithPublicKey(nric);
    const encryptedPassword = encryptStringWithPublicKey(password);
    console.log("captcha login Response",captchaResponse)
    const url = `${ROOT_URL}/users/login/v3`;
    return axios.post(url, {
        email,
        password: encryptedPassword,
        captchaResponse
    }).then((response) => {
        callback(response.data, null);
        return {
            type: DO_LOGIN_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log(error);
        callback(null, error);
        return {
            type: DO_LOGIN_ERROR,
            payload: error
        };
    });
}

export function resetLoginOTPEmail() {
    return {
        type: RESET_VERIFY_LOGIN_EMAIL_OTP,
    };
}

export function generateLoginOTPEmail(data, callback) {
    const encryptedNric = encryptStringWithPublicKey(data.nric);
    const url = `${ROOT_URL}/users/generateLoginOTPEmailCode`;
    return axios.post(url, {
        identifier: encryptedNric
    }).then((response) => {
        console.log('generateLoginOTPEmailCode', response);
        callback(response.status, null);
        return {
            type: GENERATE_LOGIN_EMAIL_OTP_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('generateLoginOTPEmailCode', error);
        callback(null, error);
        return {
            type: GENERATE_LOGIN_EMAIL_OTP_ERROR,
            payload: error
        };
    });
}

export function verifyLoginOTPEmail(data, callback) {
    const encryptedNric = encryptStringWithPublicKey(data.nric);
    const url = `${ROOT_URL}/users/verifyLoginOTPEmailCode`;
    return axios.post(url, {
        identifier: encryptedNric,
        otp: data.otp
    }).then((response) => {
        console.log('verifyLoginOTPEmailCode', response);
        callback(response.data, null);
        return {
            type: VERIFY_LOGIN_EMAIL_OTP_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('verifyLoginOTPEmailCode', error);
        callback(null, error);
        return {
            type: VERIFY_LOGIN_EMAIL_OTP_ERROR,
            payload: error
        };
    });
}

export function verifyLoginOTPEmail2(data, callback) {
    console.log("verifyLoginOTPEmail2")
    const encryptedNric = encryptStringWithPublicKey(data.nric);
    const url = `${ROOT_URL}/users/verifyLoginOTPEmailCode/v1`;
    return axios({
        method: 'POST',
        url,
        data: {
            identifier: encryptedNric,
            otp: data.otp
        },
        headers: {
            'accessToken': data.accessToken
        }
    }).then((response) => {
        console.log('verifyLoginOTPEmailCode', response);
        callback(response.data, null);
        return {
            type: VERIFY_LOGIN_EMAIL_OTP_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('verifyLoginOTPEmailCode', error);
        callback(null, error);
        return {
            type: VERIFY_LOGIN_EMAIL_OTP_ERROR,
            payload: error
        };
    });
}

export function verifyChatCall(accessToken, callback) {
    console.log("verifyChatCall")
    const url = `${ROOT_URL}/chats`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('verifyChatCall', response);
        return {
            type: CHAT_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('verifyChatCall', error);
        return {
            type: CHAT_ERROR,
            payload: error
        }
    });
}

// export function doRelogin({email, password, birthdate}, callback) {
//
//     // const encryptedNric = encryptStringWithPublicKey(nric);
//     const encryptedPassword = encryptStringWithPublicKey(password);
//
//     const url = `${ROOT_URL}/users/login/v2`;
//     return axios.post(url, {
//         email,
//         password: encryptedPassword,
//         birthdate,
//     }).then((response) => {
//         callback(response.status, null);
//         return {
//             type: DO_RELOGIN_SUCCESS,
//             payload: response
//         };
//     }).catch((error) => {
//         console.log(error);
//         callback(null, error);
//         return {
//             type: DO_LOGIN_ERROR,
//             payload: error
//         };
//     });
// }


export function doReloginV3({email, password}, callback) {

    // const encryptedNric = encryptStringWithPublicKey(nric);
    const encryptedPassword = encryptStringWithPublicKey(password);

    const url = `${ROOT_URL}/users/login/v3`;
    return axios.post(url, {
        email,
        password: encryptedPassword,
    }).then((response) => {
        callback(response.data.user, null);
        return {
            type: DO_RELOGIN_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log(error);
        callback(null, error);
        return {
            type: DO_LOGIN_ERROR,
            payload: error
        };
    });
}

export function submitFlexClaim({data, attachments, accessToken}, callback) {
    // get param data
    const {receiptNo, provider, amount} = data;
    // setup form data;
    let formData = new FormData();
    formData.append('recordID', '1');
    formData.append('receiptNo', receiptNo);
    formData.append('benefitID', '1');
    formData.append('visitDate', '06/11/2018');
    formData.append('diagnosisCode', '1');
    formData.append('providerName', provider);
    formData.append('amount', amount);
    formData.append('currency', '1');
    formData.append('remarks', '1');
    for (let i = 0; i < attachments.length; i++) {
        formData.append(`attachment[${i}]`, attachments[i]);
    }
    // send formData to API
    const url = `${ROOT_URL}/eclaims`;
    return axios({
        method: 'POST',
        url,
        data: formData,
        headers: {
            'Accesstoken': accessToken,
            'Content-Type': 'multipart/form-data'
        }
    }).then((response) => {
        // console.log('doSubmitFlexClaim', response);
        callback(response.data.eclaim, null);
        return {
            type: SUBMIT_FLEX_CLAIM_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('doSubmitFlexClaim', error);
        callback(null, error);
        return {
            type: SUBMIT_FLEX_CLAIM_ERROR,
            payload: error
        };
    });
}

export function getClaims(accessToken) {
    // console.log(accessToken);
    const url = `${ROOT_URL}/eclaims`;
    return axios({
        method: 'GET',
        url,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        // console.log('getClaims', response);
        return {
            type: GET_CLAIMS,
            payload: response
        };
    }).catch((error) => {
        console.log('getClaims', error);
        return {
            type: GET_CLAIMS,
            payload: error
        }
    });
}

export function submitInpatientClaim({data, attachments, accessToken}, captchaResponse, callback) {
    // setup form data;
    let companyIdQuery = `?companyId=${data.companyId}&captchaResponse=${captchaResponse}`;
    let formData = new FormData();
    Object.keys(data).forEach(key => {
        let value = data[key];
        //use key and value here
        if (value) {
            // console.log(key, ' - ', value);
            formData.append(key, value);
        }
    });
    for (let i = 0; i < attachments.length; i++) {
        formData.append('attachment', attachments[i]);
    }
    // send formData to API
    const url = `${ROOT_URL}/inpatientclaim${companyIdQuery}`;
    return axios({
        method: 'POST',
        url,
        data: formData,
        headers: {
            'Accesstoken': accessToken,
            'Content-Type': 'multipart/form-data'
        }
    }).then((response) => {
        if((response && response.code == '303') || (response && response.data && response.data.statusCode == '303')){
            let err = {
                message: "There are suspicious file(s) detected, please scan the file(s) with antivirus software before uploading."
            }
            callback(null, err);
            return {
                type: SUBMIT_INPATIENT_CLAIM_ERROR,
                payload: err
            };
        }else{
            console.log('submitInpatientClaim---->>>', response);
            callback(response.data, null);
            return {
                type: SUBMIT_INPATIENT_CLAIM_SUCCESS,
                payload: response
            };
        }
    }).catch((error) => {
        console.log('submitInpatientClaim', error);
        callback(null, error);
        return {
            type: SUBMIT_INPATIENT_CLAIM_ERROR,
            payload: error
        };
    });
}

export function getInpatientClaimOptions(accessToken, callback) {
    const url = `${ROOT_URL}/inpatientclaimoptions`;
    return axios({
        method: 'GET',
        url,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        // console.log('getInpatientClaimOptions', response);
        return {
            type: GET_INPATIENT_CLAIM_OPTIONS_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getInpatientClaimOptions', error);
        return {
            type: GET_INPATIENT_CLAIM_OPTIONS_ERROR,
            payload: error
        }
    });
}

export function getInpatientClaims(accessToken, callback) {
    const url = `${ROOT_URL}/inpatientclaim`;
    return axios({
        method: 'GET',
        url,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getInpatientClaims', response);
        return {
            type: GET_INPATIENT_CLAIM_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getInpatientClaims', error);
        return {
            type: GET_INPATIENT_CLAIM_ERROR,
            payload: error
        }
    });
}

export function submitOutpatientClaim({data, attachments, accessToken}, captchaResponse, callback) {
    // setup form data;
    let companyIdQuery = `?companyId=${data.companyId}&captchaResponse=${captchaResponse}`;
    let formData = new FormData();
    Object.keys(data).forEach(key => {
        let value = data[key];
        if (value) {
            formData.append(key, value);
        }
    });
    // setup form data;
    // let formData = new FormData();
    // formData.append('claimantId', data.claimantId);
    // formData.append('receiptNo', data.receiptNo);
    // formData.append('benefitId', data.benefitId);
    // formData.append('visitDate', data.visitDate);
    // formData.append('diagnosisCode', data.diagnosisCode);
    // formData.append('providerName', data.providerName);
    // formData.append('amount', data.amount);
    // formData.append('currency', data.currency);
    // formData.append('remarks', data.remarks);
    // formData.append('prePostHospitalisation', data.prePostHospitalisation);
    for (let i = 0; i < attachments.length; i++) {
        formData.append('attachment', attachments[i]);
    }
    // send formData to API
    const url = `${ROOT_URL}/outpatientclaim/v2${companyIdQuery}`;
    return axios({
        method: 'POST',
        url,
        data: formData,
        headers: {
            'Accesstoken': accessToken,
            'Content-Type': 'multipart/form-data'
        }
    }).then((response) => {
        if((response && response.code == '303') || (response && response.data && response.data.statusCode == '303')){
            let err = {
                message: "There are suspicious file(s) detected, please scan the file(s) with antivirus software before uploading."
            }
            callback(null, err);
            return {
                type: SUBMIT_OUTPATIENT_CLAIM_ERROR,
                payload: err
            };
        }else{
            callback(response.data, null);
            return {
                type: SUBMIT_OUTPATIENT_CLAIM_SUCCESS,
                payload: response
            };
        }
    }).catch((error) => {
        console.log('submitOutpatientClaim', error);
        callback(null, error);
        return {
            type: SUBMIT_OUTPATIENT_CLAIM_ERROR,
            payload: error
        };
    });
}

export function getClaimOptions(accessToken, companyId, callback) {

    let companyIdQuery = `?companyId=${companyId}`;
    const url = `${ROOT_URL}/config/claimoptions${companyIdQuery}`;
    return axios({
        method: 'GET',
        url,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getClaimOptions', response);
        return {
            type: GET_CLAIM_OPTIONS_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getClaimOptions', error);
        return {
            type: GET_CLAIM_OPTIONS_ERROR,
            payload: error
        }
    });
}

export function getClaimOptionsProfile(accessToken, companyId, callback) {

    let companyIdQuery = `?companyId=${companyId}`;
    const url = `${ROOT_URL}/profile/config/claimoptions${companyIdQuery}`;
    return axios({
        method: 'GET',
        url,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getClaimOptions', response);
        return {
            type: GET_CLAIM_OPTIONS_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getClaimOptions', error);
        return {
            type: GET_CLAIM_OPTIONS_ERROR,
            payload: error
        }
    });
}

export function getClaimOptionsElog(accessToken, companyId, callback) {

    let companyIdQuery = `?companyId=${companyId}`;
    const url = `${ROOT_URL}/elog/config/claimoptions${companyIdQuery}`;
    return axios({
        method: 'GET',
        url,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getClaimOptions', response);
        return {
            type: GET_CLAIM_OPTIONS_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getClaimOptions', error);
        return {
            type: GET_CLAIM_OPTIONS_ERROR,
            payload: error
        }
    });
}

export function getClaimOptionsEclaim(accessToken, companyId, callback) {

    let companyIdQuery = `?companyId=${companyId}`;
    const url = `${ROOT_URL}/claims/config/claimoptions${companyIdQuery}`;
    return axios({
        method: 'GET',
        url,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getClaimOptions', response);
        return {
            type: GET_CLAIM_OPTIONS_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getClaimOptions', error);
        return {
            type: GET_CLAIM_OPTIONS_ERROR,
            payload: error
        }
    });
}

export function getBankOptions(callback) {
    const url = `${ROOT_URL}/config/banklists`;
    return axios({
        method: 'GET',
        url,
    }).then((response) => {
        console.log('getBankOptions', response);
        return {
            type: GET_BANK_OPTIONS_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getBankOptions', error);
        return {
            type: GET_BANK_OPTIONS_ERROR,
            payload: error.message
        }
    });
}

export function getOutpatientClaims(accessToken, callback) {
    const url = `${ROOT_URL}/outpatientclaim`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getOutpatientClaims', response);
        return {
            type: GET_OUTPATIENT_CLAIM_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getOutpatientClaims', error);
        return {
            type: GET_OUTPATIENT_CLAIM_ERROR,
            payload: error
        }
    });
}

export function deleteOutpatientClaims({transactionNo, accessToken, selectedCompanyId}, callback) {
    let companyIdQuery = `?companyId=${selectedCompanyId}`;
    const url = `${ROOT_URL}/outpatientclaim/${transactionNo}${companyIdQuery}`;
    return axios({
        method: 'DELETE',
        url,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('deleteOutpatientClaims', response)
        callback(true);
        return {
            type: DELETE_OUTPATIENT_CLAIM_SUCCESS,
            payload: transactionNo
        };
    }).catch((error) => {
        console.log('deleteOutpatientClaims', error);
        callback(false);
        return {
            type: DELETE_OUTPATIENT_CLAIM_ERROR,
            payload: error
        };
    })
}

export function deleteOutpatientIdClaims({claimId, accessToken, selectedCompanyId}, callback) {
    let companyIdQuery = `?companyId=${selectedCompanyId}`;
    const url = `${ROOT_URL}/outpatientclaim/delete/${claimId}${companyIdQuery}`;
    console.log("claimId", claimId)
    return axios({
        method: 'DELETE',
        url,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('deleteOutpatientClaims', response)
        callback(true);
        return {
            type: DELETE_OUTPATIENT_CLAIM_ID_SUCCESS,
            payload: claimId
        };
    }).catch((error) => {
        console.log('deleteOutpatientClaims', error);
        callback(false);
        return {
            type: DELETE_OUTPATIENT_CLAIM_ID_ERROR,
            payload: error
        };
    })
}

export function deleteInpatientIdClaims({claimId, accessToken, selectedCompanyId}, callback) {
    let companyIdQuery = `?companyId=${selectedCompanyId}`;
    const url = `${ROOT_URL}/inpatientclaim/delete/${claimId}${companyIdQuery}`;
    console.log("claimId", claimId)
    return axios({
        method: 'DELETE',
        url,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('deleteOutpatientClaims', response)
        callback(true);
        return {
            type: DELETE_INPATIENT_CLAIM_ID_SUCCESS,
            payload: claimId
        };
    }).catch((error) => {
        console.log('deleteOutpatientClaims', error);
        callback(false);
        return {
            type: DELETE_INPATIENT_CLAIM_ID_ERROR,
            payload: error
        };
    })
}


//
// export function updateOutpatientClaim({data, attachments, accessToken, oldAttachments, transactionNo}, callback) {
//     // setup form data;
//     let formData = new FormData();
//     Object.keys(data).forEach(key => {
//         let value = data[key];
//         if (value) {
//             formData.append(key, value);
//         }
//     });
//     // formData.append('claimantId', data.claimantId);
//     // formData.append('receiptNo', data.receiptNo);
//     // formData.append('benefitId', data.benefitId);
//     // formData.append('visitDate', data.visitDate);
//     // formData.append('diagnosisCode', data.diagnosisCode);
//     // formData.append('providerName', data.providerName);
//     // formData.append('amount', data.amount);
//     // formData.append('currency', data.currency);
//     // formData.append('remarks', data.remarks);
//     // formData.append('prePostHospitalisation', data.prePostHospitalisation);
//     formData.append('oldAttachment', JSON.stringify(oldAttachments));
//     for (let i = 0; i < attachments.length; i++) {
//         formData.append('attachment', attachments[i]);
//     }
//     // for (let i = 0; i < oldAttachments.length; i++) {
//     //     formData.append('oldAttachment', oldAttachments[i]);
//     // }
//     // formData.append('attachment', attachments);
//     // send formData to API
//     const url = `${ROOT_URL}/outpatientclaim/v2/${transactionNo}`;
//     return axios({
//         method: 'PUT',
//         url,
//         data: formData,
//         headers: { 'Accesstoken' : accessToken, 'Content-Type' : 'multipart/form-data'}
//     }).then((response) => {
//         console.log('submitOutpatientClaim', response);
//         callback(response.data, null);
//         return {
//             type: UPDATE_OUTPATIENT_CLAIM_SUCCESS,
//             payload: response
//         };
//     }).catch((error) => {
//         console.log('submitOutpatientClaim', error);
//         callback(null, error);
//         return {
//             type: UPDATE_OUTPATIENT_CLAIM_ERROR,
//             payload: error
//         };
//     });
// }


export function updateOutpatientClaim({data, attachments, accessToken, nric, oldAttachments, transactionNo}, callback) {
    // setup form data;
    let companyIdQuery = `?companyId=${data.companyId}`;
    let formData = new FormData();
    Object.keys(data).forEach(key => {
        let value = data[key];
        if (value) {
            formData.append(key, value);
        }
    });
    // formData.append('claimantId', data.claimantId);
    // formData.append('receiptNo', data.receiptNo);
    // formData.append('benefitId', data.benefitId);
    // formData.append('visitDate', data.visitDate);
    // formData.append('diagnosisCode', data.diagnosisCode);
    // formData.append('providerName', data.providerName);
    // formData.append('amount', data.amount);
    // formData.append('currency', data.currency);
    // formData.append('remarks', data.remarks);
    // formData.append('prePostHospitalisation', data.prePostHospitalisation);
    formData.append('oldAttachment', JSON.stringify(oldAttachments));
    for (let i = 0; i < attachments.length; i++) {
        formData.append('attachment', attachments[i]);
    }
    // for (let i = 0; i < oldAttachments.length; i++) {
    //     formData.append('oldAttachment', oldAttachments[i]);
    // }
    // formData.append('attachment', attachments);
    // send formData to API

    const encryptedNric = encryptStringWithPublicKey(nric);
    const encryptText = encodeURIComponent(encryptedNric);
    // console.log('encryptText', encryptText);
    const url_1 = `${ROOT_URL}/outpatientclaim/v2/web/${encryptText}/${transactionNo}${companyIdQuery}`;
    const url = encodeURI(url_1)
    console.log('url-updateOutpatientClaim', url);
    return axios({
        method: 'PUT',
        url,
        data: formData,
        headers: {
            'Accesstoken': accessToken,
            'Content-Type': 'multipart/form-data'
        }
    }).then((response) => {
        console.log('updateOutpatientClaim', response);
        callback(response.data, null);
        return {
            type: UPDATE_OUTPATIENT_CLAIM_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('updateOutpatientClaim', error);
        callback(null, error);
        return {
            type: UPDATE_OUTPATIENT_CLAIM_ERROR,
            payload: error
        };
    });
}

export function updateUnsubmittedOutpatientClaim({data, attachments, accessToken, nric, oldAttachments, claimId}, callback) {
    // setup form data;
    let companyIdQuery = `?companyId=${data.companyId}`;
    let formData = new FormData();
    Object.keys(data).forEach(key => {
        let value = data[key];
        if (value) {
            formData.set(key, value);
        }
    });
    // formData.set('claimantId', data.claimantId);
    // formData.set('receiptNo', data.receiptNo);
    // formData.set('benefitId', data.benefitId);
    // formData.set('visitDate', data.visitDate);
    // formData.set('diagnosisCode', data.diagnosisCode);
    // formData.set('providerName', data.providerName);
    // formData.set('amount', data.amount);
    // formData.set('currency', data.currency);
    // formData.set('remarks', data.remarks);
    // formData.set('prePostHospitalisation', data.prePostHospitalisation);
    formData.set('oldAttachment', JSON.stringify(oldAttachments));
    for (let i = 0; i < attachments.length; i++) {
        formData.append('attachment', attachments[i]);
    }
    console.log("check formdata", attachments);
    // for (let i = 0; i < oldAttachments.length; i++) {
    //     formData.append('oldAttachment', oldAttachments[i]);
    // }
    // formData.set('attachment', attachments);
    // send formData to API

    // console.log('encryptText', encryptText);
    const url_1 = `${ROOT_URL}/outpatientclaim/v3/${claimId}/web${companyIdQuery}`;
    const url = encodeURI(url_1)
    console.log('url-updateOutpatientClaim', url);
    return axios({
        method: 'PUT',
        url,
        data: formData,
        headers: {
            'Accesstoken': accessToken,
            'Content-Type': 'multipart/form-data'
        }
    }).then((response) => {
        console.log('updateOutpatientClaim', response);
        callback(response.data, null);
        return {
            type: UPDATE_UNSUBMITTED_OUTPATIENT_CLAIM_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('updateOutpatientClaim', error);
        callback(null, error);
        return {
            type: UPDATE_UNSUBMITTED_OUTPATIENT_CLAIM_ERROR,
            payload: error
        };
    });
}

export function deleteInpatientClaims({transactionNo, accessToken, selectedCompanyId}, callback) {
    let companyIdQuery = `?companyId=${selectedCompanyId}`;
    const url = `${ROOT_URL}/inpatientclaim/${transactionNo}${companyIdQuery}`;
    return axios({
        method: 'DELETE',
        url,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('deleteInpatientClaims', response)
        callback(true);
        return {
            type: DELETE_INPATIENT_CLAIM_SUCCESS,
            payload: transactionNo
        };
    }).catch((error) => {
        console.log('deleteInpatientClaims', error);
        callback(false);
        return {
            type: DELETE_INPATIENT_CLAIM_ERROR,
            payload: error
        };
    })
}

export function updateInpatientClaim({data, attachments, oldAttachments, accessToken, transactionNo}, callback) {
    // setup form data;
    let companyIdQuery = `?companyId=${data.companyId}`;
    let formData = new FormData();
    Object.keys(data).forEach(key => {
        let value = data[key];
        if (value) {
            formData.append(key, value);
        }
    });
    for (let i = 0; i < attachments.length; i++) {
        formData.append('attachment', attachments[i]);
    }
    formData.append('oldAttachment', JSON.stringify(oldAttachments));
    // send formData to API
    const url = `${ROOT_URL}/inpatientclaim/${transactionNo}${companyIdQuery}`;
    return axios({
        method: 'PUT',
        url,
        data: formData,
        headers: {
            'Accesstoken': accessToken,
            'Content-Type': 'multipart/form-data'
        }
    }).then((response) => {
        console.log('updateInpatientClaim', response);
        callback(response.data, null);
        return {
            type: UPDATE_INPATIENT_CLAIM_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('updateInpatientClaim', error);
        callback(null, error);
        return {
            type: UPDATE_INPATIENT_CLAIM_ERROR,
            payload: error
        };
    });
}

export function updateUnsubmittedInpatientClaim({data, attachments, oldAttachments, accessToken, claimId}, callback) {
    // setup form data;
    let companyIdQuery = `?companyId=${data.companyId}`;
    let formData = new FormData();
    Object.keys(data).forEach(key => {
        let value = data[key];
        if (value) {
            formData.set(key, value);
        }
    });
    for (let i = 0; i < attachments.length; i++) {
        formData.append('attachment', attachments[i]);
    }
    formData.set('oldAttachment', JSON.stringify(oldAttachments));
    // send formData to API
    const url = `${ROOT_URL}/inpatientclaim/update/${claimId}/web${companyIdQuery}`;
    return axios({
        method: 'PUT',
        url,
        data: formData,
        headers: {
            'Accesstoken': accessToken,
            'Content-Type': 'multipart/form-data'
        }
    }).then((response) => {
        console.log('updateInpatientClaim', response);
        callback(response.data.inpatientclaims, null);
        return {
            type: UPDATE_UNSUBMITTED_INPATIENT_CLAIM_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('updateInpatientClaim', error);
        callback(null, error);
        return {
            type: UPDATE_UNSUBMITTED_INPATIENT_CLAIM_ERROR,
            payload: error
        };
    });
}

export function getClinicList(accessToken, companyId, callback) {
    let companyIdQuery = `?companyId=${companyId}`;

    console.log('companyIdQuery',companyIdQuery)

    const url = `${ROOT_URL}/clinics${companyIdQuery}`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getClinicList', response);
        return {
            type: GET_CLINIC_LIST_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getClinicList', error);
        return {
            type: GET_CLINIC_LIST_ERROR,
            payload: error
        }
    });
}

export function getClinicLocatorListBySysAdmin(accessToken, companyId, nric, callback) {
    store.dispatch({type: GET_CLINIC_LIST_REQUEST})
    let companyIdQuery = `?companyId=${companyId}&nric=${nric}`;

    const url = `${ROOT_URL}/sysadmin/clinics${companyIdQuery}`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: { 'Accesstoken' : accessToken }
    }).then((response) => {
        callback(response, null);
        console.log('getClinicLocatorListBySysAdmin', response);
        return {
            type: GET_CLINIC_LIST_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        callback(null, error);
        console.log('getClinicLocatorListBySysAdmin', error);
        return {
            type: GET_SYSADMIN_CLINIC_LIST_ERROR,
            payload: error
        }
    });
}

export function getClinicLocatorList(accessToken, companyId, callback) {
    let companyIdQuery = `?companyId=${companyId}`;

    const url = `${ROOT_URL}/cliniclocator/clinics${companyIdQuery}`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getClinicLocatorList', response);
        return {
            type: GET_CLINIC_LIST_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getClinicLocatorList', error);
        return {
            type: GET_CLINIC_LIST_ERROR,
            payload: error
        }
    });
}

export function getAllClaims({claimFilterOptions, accessToken, companyId}, callback) {
    // construct url based on field "claimFilterOptions"
    const {fromDate, toDate, filterByClaimant, filterByCompany} = claimFilterOptions;
    const convertedFromDate = Moment(fromDate).format('YYYYMMDD');
    const convertedToDate = Moment(toDate).format('YYYYMMDD');
    let uuidQuery = '';
    let companyIdQuery = `&companyId=${companyId}` || null;
    if (filterByClaimant) {
        uuidQuery = `&uuid=${filterByClaimant}`;
    }
    if (filterByCompany) {
        companyIdQuery = `&companyId=${filterByCompany}`;
    }
    const url = `${ROOT_URL}/claims?from=${convertedFromDate}&to=${convertedToDate}${companyIdQuery}${uuidQuery}`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getAllClaims', response);
        if (callback) {
            callback(response.data, null);
        }

        return {
            type: GET_CLAIMS_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getAllClaims', error);
        if (callback) {
            callback(null, error);
        }
        return {
            type: GET_CLAIMS_ERROR,
            payload: error
        }
    });
}

// export function getSingleInpatientClaim({accessToken, transactionNo}, callback) {
//     const url = `${ROOT_URL}/inpatientclaim/${transactionNo}`;
//     return axios({
//         method: 'GET',
//         url,
//         data: {},
//         headers: { 'Accesstoken' : accessToken }
//     }).then((response) => {
//         console.log('getSingleInpatientClaim', response);
//         return {
//             type: GET_SINGLE_INPATIENT_CLAIM_SUCCESS,
//             payload: response
//         };
//     }).catch((error) => {
//         console.log('getSingleInpatientClaim', error);
//         return {
//             type: GET_SINGLE_INPATIENT_CLAIM_ERROR,
//             payload: error.message
//         }
//     });
// }

export function getSingleInpatientClaim({accessToken, nric, transactionNo, companyId, useRecordId}, callback) {
    const encryptedNric = encryptStringWithPublicKey(nric);
    const encryptText = encodeURIComponent(encryptedNric);
    let companyIdQuery = `?companyId=${companyId}`;
    let useRecordIdQuery = useRecordId ? `&useRecordId=${useRecordId}` : '';

    // console.log('encryptText', encryptText);
    const url = `${ROOT_URL}/inpatientclaim/v2/${encryptText}/${transactionNo}/${useRecordId}`;
    // const url = encodeURI(url_1)
    console.log('url-getSingleInpatientClaim', url);
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getSingleInpatientClaim', response);
        return {
            type: GET_SINGLE_INPATIENT_CLAIM_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getSingleInpatientClaim', error);
        return {
            type: GET_SINGLE_INPATIENT_CLAIM_ERROR,
            payload: error
        }
    });
}


export function getSingleInpatientIdClaim({accessToken, nric, claimId, companyId}, callback) {
    const encryptedNric = encryptStringWithPublicKey(nric);
    const encryptText = encodeURIComponent(encryptedNric);
    let companyIdQuery = `?companyId=${companyId}`;
    // console.log('encryptText', encryptText);
    const url_1 = `${ROOT_URL}/inpatientclaim/v3/${claimId}${companyIdQuery}`;
    const url = encodeURI(url_1)
    console.log('url-getSingleInpatientClaim', url);
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getSingleInpatientClaim', response);
        return {
            type: GET_SINGLE_INPATIENT_CLAIM_ID_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getSingleInpatientClaim', error);
        return {
            type: GET_SINGLE_INPATIENT_CLAIM_ID_ERROR,
            payload: error
        }
    });
}
//
// export function getSingleOutpatientClaim({accessToken, transactionNo}, callback) {
//     const url = `${ROOT_URL}/outpatientclaim/${transactionNo}`;
//     return axios({
//         method: 'GET',
//         url,
//         data: {},
//         headers: { 'Accesstoken' : accessToken }
//     }).then((response) => {
//         console.log('getSingleOutpatientClaim', response);
//         return {
//             type: GET_SINGLE_OUTPATIENT_CLAIM_SUCCESS,
//             payload: response
//         };
//     }).catch((error) => {
//         console.log('getSingleOutpatientClaim', error);
//         return {
//             type: GET_SINGLE_OUTPATIENT_CLAIM_ERROR,
//             payload: error.message
//         }
//     });
// }

export function getSingleOutpatientByIdClaim({accessToken, nric, claimId, companyId}, callback) {

    const encryptedNric = encryptStringWithPublicKey(nric);
    // console.log('encryptedNric', encryptedNric);
    const encryptedText = encodeURIComponent(encryptedNric);
    let companyIdQuery = `?companyId=${companyId}`;

    // console.log('encryptedText', encryptedText);
    // const url_1 = `${ROOT_URL}/outpatientclaim/v3/${claimId}${companyIdQuery}`;
    const url_1 = `${ROOT_URL}/outpatientclaim/v3/${claimId}${companyIdQuery}`;
    const url = encodeURI(url_1)
    console.log('url-getSingleOutpatientClaim', url);
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getSingleOutpatientClaim', response);
        return {
            type: GET_SINGLE_OUTPATIENT_CLAIM_ID_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getSingleOutpatientClaim', error);
        return {
            type: GET_SINGLE_OUTPATIENT_CLAIM_ID_ERROR,
            payload: error
        }
    });
}


export function getSingleOutpatientClaim({accessToken, nric, transactionNo, companyId, useRecordId}, callback) {

    const encryptedNric = encryptStringWithPublicKey(nric);
    // console.log('encryptedNric', encryptedNric);
    const encryptedText = encodeURIComponent(encryptedNric);
    let companyIdQuery = `?companyId=${companyId}`;
    let useRecordIdQuery = useRecordId ? `&useRecordId=${useRecordId}` : '';

    // console.log('encryptedText', encryptedText);
    const url_1 = `${ROOT_URL}/outpatientclaim/v2/web/${encryptedText}/${transactionNo}${companyIdQuery}${useRecordIdQuery}`;
    const url = encodeURI(url_1)
    
    console.log('url-getSingleOutpatientClaim', url);
    
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getSingleOutpatientClaim', response);
        return {
            type: GET_SINGLE_OUTPATIENT_CLAIM_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getSingleOutpatientClaim', error);
        return {
            type: GET_SINGLE_OUTPATIENT_CLAIM_ERROR,
            payload: error
        }
    });
}

export function getUserProfile(accessToken, uuid) {
    const url = `${ROOT_URL}/profile/users/${uuid}`;
    return axios({
        method: 'GET',
        url,
        data: {},
        responseType: 'arraybuffer',
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getUserProfile', response);
        return {
            type: GET_USER_PROFILE_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getUserProfile', error);
        return {
            type: GET_USER_PROFILE_ERROR,
            payload: error
        }
    });
}

export function getUserProfilePhoto2(accessToken, callback) {
    const url = `${ROOT_URL}/profile/get/users/profilePhoto`;
    return axios({
        method: 'GET',
        url,
        data: {},
        responseType: 'arraybuffer',
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getUserProfilePhoto', response);
        return {
            type: GET_USER_PROFILE_PHOTO_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getUserProfilePhoto', error);
        return {
            type: GET_USER_PROFILE_PHOTO_ERROR,
            payload: error
        }
    });
}

export function getUserProfilePhoto(accessToken, callback) {
    const url = `${ROOT_URL}/users/uuid/profilePhoto`;
    return axios({
        method: 'GET',
        url,
        data: {},
        responseType: 'arraybuffer',
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getUserProfilePhoto', response);
        return {
            type: GET_USER_PROFILE_PHOTO_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getUserProfilePhoto', error);
        return {
            type: GET_USER_PROFILE_PHOTO_ERROR,
            payload: error
        }
    });
}

export function getUnsubmittedClaimAttachment({accessToken, attchId, id, mimeType}, callback) {
    let mimeTypeQuery = `?imagememe=${mimeType}`;
    const url = `${ROOT_URL}/outpatient/${id}/attachments/${attchId}${mimeTypeQuery}`;
    return axios({
        method: 'GET',
        url,
        data: {},
        responseType: 'arraybuffer',
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getUnsubmittedClaimAttachment', response);
        return {
            type: GET_CLAIM_PHOTO_SUCCESS,
            payload: response,
            dataId: attchId
        };
    }).catch((error) => {
        console.log('getUnsubmittedClaimAttachment', error);
        return {
            type: GET_CLAIM_PHOTO_ERROR,
            payload: error
        }
    });
}

export function submitProfileNewProfilePhoto({attachment, accessToken}, callback) {
    // setup form data;
    let formData = new FormData();
    formData.append('file', attachment[0]);
    const url = `${ROOT_URL}/profile/users/profilePhoto/web`;
    return axios({
        method: 'POST',
        url,
        data: formData,
        headers: {
            'Accesstoken': accessToken,
            'Content-Type': 'multipart/form-data'
        }
    }).then((response) => {
        if((response && response.code == '303') || (response && response.data && response.data.statusCode == '303')){
            let err = {
                message: "There are suspicious file(s) detected, please scan the file(s) with antivirus software before uploading."
            }
            callback(null, err);
            return {
                type: UPDATE_USER_PROFILE_PHOTO_ERROR,
                payload: err
            };
        }else{
            console.log('submitNewProfilePhoto', response);
            callback(response.status, null);
            return {
                type: UPDATE_USER_PROFILE_PHOTO_SUCCESS,
                payload: response
            };
        }
    }).catch((error) => {
        console.log('submitNewProfilePhoto', error);
        callback(null, error);
        return {
            type: UPDATE_USER_PROFILE_PHOTO_ERROR,
            payload: error
        };
    });
}

export function submitNewProfilePhoto({attachment, accessToken}, callback) {
    // setup form data;
    let formData = new FormData();
    formData.append('file', attachment[0]);
    const url = `${ROOT_URL}/users/uuid/profilePhoto`;
    return axios({
        method: 'POST',
        url,
        data: formData,
        headers: {
            'Accesstoken': accessToken,
            'Content-Type': 'multipart/form-data'
        }
    }).then((response) => {
        console.log('submitNewProfilePhoto', response);
        callback(response.status, null);
        return {
            type: UPDATE_USER_PROFILE_PHOTO_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('submitNewProfilePhoto', error);
        callback(null, error);
        return {
            type: UPDATE_USER_PROFILE_PHOTO_ERROR,
            payload: error
        };
    });
}

export function updateUserProfileInformation({data, accessToken}, callback) {
    const url = `${ROOT_URL}/users/id`;
    return axios({
        method: 'PUT',
        url,
        data,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('updateUserProfileInformation', response);
        callback(response.data.user, null);
        return {
            type: UPDATE_USER_PROFILE_INFORMATION_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('updateUserProfileInformation', error);
        callback(null, error);
        return {
            type: UPDATE_USER_PROFILE_INFORMATION_ERROR,
            payload: error
        };
    });
}

export function verifyPassword ({id, password, accessToken}, callback) {
    const encryptedPassword = encryptStringWithPublicKey(password);
    console.log("id, password ", id, password)
    const url = `${ROOT_URL}/users/verifyPassword`;
    return axios({
        method: 'POST',
        url,
        data:{
            id,
            password: encryptedPassword,
        },
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('verifyPassword', response);
        callback(response.data, null);
        return {
            type: VERIFY_PASSWORD_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('verifyPassword', error);
        callback(null, error);
        return {
            type: VERIFY_PASSWORD_ERROR,
            payload: error
        };
    });
}

export function updateProfileUserProfileInformation({data, accessToken}, callback) {
    const url = `${ROOT_URL}/profile/users/update`;
    return axios({
        method: 'PUT',
        url,
        data,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('updateUserProfileInformation', response);
        callback(response.data.user, null);
        return {
            type: UPDATE_USER_PROFILE_INFORMATION_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('updateUserProfileInformation', error);
        callback(null, error);
        return {
            type: UPDATE_USER_PROFILE_INFORMATION_ERROR,
            payload: error
        };
    });
}

export function updateProfileUserProfileChangeNameAndNRIC({data, accessToken}, callback) {
    console.log('updateUserProfileChangeNameAndNRIC-', data);
    const url = `${ROOT_URL}/profile/user/requestChangeNricAndName`;
    data.nric = encryptStringWithPublicKey(data.nric);

    return axios({
        method: 'POST',
        url,
        data,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('updateUserProfileChangeNameAndNRIC', response);
        callback(response.status, null);
        return {
            type: UPDATE_USER_CHANGE_NAME_AND_NRIC_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('updateUserProfileChangeNameAndNRIC', error);
        callback(null, error);
        return {
            type: UPDATE_USER_CHANGE_NAME_AND_NRIC_ERROR,
            payload: error
        };
    });
}


export function updateUserProfileChangeNameAndNRIC({data, accessToken}, callback) {
    console.log('updateUserProfileChangeNameAndNRIC-', data);
    const url = `${ROOT_URL}/user/requestChangeNricAndName`;
    data.nric = encryptStringWithPublicKey(data.nric);

    return axios({
        method: 'POST',
        url,
        data,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('updateUserProfileChangeNameAndNRIC', response);
        callback(response.status, null);
        return {
            type: UPDATE_USER_CHANGE_NAME_AND_NRIC_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('updateUserProfileChangeNameAndNRIC', error);
        callback(null, error);
        return {
            type: UPDATE_USER_CHANGE_NAME_AND_NRIC_ERROR,
            payload: error
        };
    });
}

export function updateUserProfileChangePassword({data, accessToken}, callback) {
    const url = `${ROOT_URL}/profile/users/changePassword`;
    data.oldPassword = encryptStringWithPublicKey(data.oldPassword);
    data.newPassword = encryptStringWithPublicKey(data.newPassword);
    delete data.newPasswordConfirm;
    return axios({
        method: 'PUT',
        url,
        data,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('updateUserProfileChangePassword', response);
        callback(response.status, null);
        return {
            type: UPDATE_USER_CHANGE_PASSWORD_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('updateUserProfileChangePassword', error);
        callback(null, error);
        return {
            type: UPDATE_USER_CHANGE_PASSWORD_ERROR,
            payload: error
        };
    });
}


export function updateUserProfileGenerateChangeEmailOTP({data, accessToken}, callback) {
    const url = `${ROOT_URL}/profile/users/generateChangeEmailOTPCode`;
    return axios({
        method: 'POST',
        url,
        data,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('updateProfileGenerateChangeEmailOTP', response);
        callback(response.status, null);
        return {
            type: UPDATE_USER_GENERATE_CHANGE_EMAIL_OTP_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('updateProfileGenerateChangeEmailOTP', error);
        callback(null, error);
        return {
            type: UPDATE_USER_GENERATE_CHANGE_EMAIL_OTP_ERROR,
            payload: error
        };
    });
}

export function updateUserProfileVerifyChangeEmailOTP({data, accessToken}, callback) {
    const url = `${ROOT_URL}/profile/users/verifyChangeEmailOTPCode`;
    return axios({
        method: 'POST',
        url,
        data,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('updateUserProfileVerifyChangeEmailOTP', response);
        callback(response.status, null);
        return {
            type: UPDATE_USER_VERIFY_CHANGE_EMAIL_OTP_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('updateUserProfileVerifyChangeEmailOTP', error);
        callback(null, error);
        return {
            type: UPDATE_USER_VERIFY_CHANGE_EMAIL_OTP_ERROR,
            payload: error
        };
    });
}

export function updateClaimFilterOptions(data, callback) {
    return {
        type: UPDATE_CLAIM_FILTER_OPTIONS,
        payload: data
    };
}

export function updateVisitFilterOptions(data, callback) {
    return {
        type: UPDATE_VISIT_FILTER_OPTIONS,
        payload: data
    };
}

export function registerVerifyIdentity(data, callback) {
    const encryptedNric = encryptStringWithPublicKey(data.nric);
    // const url = `${ROOT_URL}/users/v3/verifyAccount`;
    const url = `${ROOT_URL}/users/v3/verifyAccount`;
    return axios.post(url, {
        identifier: encryptedNric,
        captchaResponse: data.robot_token
    }).then((response) => {
        console.log('registerVerifyIdentity', response.data);
        callback(response.data, null);
        return {
            type: REGISTER_VERIFY_IDENTITY_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('registerVerifyIdentity', error);
        callback(null, error);
        return {
            type: REGISTER_VERIFY_IDENTITY_ERROR,
            payload: error
        };
    });
}

export function registerGenerateOTPEmail(data, callback) {
    const encryptedNric = encryptStringWithPublicKey(data.nric);
    const url = `${ROOT_URL}/users/generateOTPEmailCode`;
    return axios.post(url, {
        identifier: encryptedNric,
        email: data.email,
        contactNo: data.contactNo,
        contactNoCountryCode: data.contactNoCountryCode,
    }).then((response) => {
        console.log('registerGenerateOTPEmail', response);
        callback(response.status, null);
        return {
            type: REGISTER_GENERATE_EMAIL_OTP_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('registerGenerateOTPEmail', error);
        callback(null, error);
        return {
            type: REGISTER_GENERATE_EMAIL_OTP_ERROR,
            payload: error
        };
    });
}

export function registerVerifyOTPEmail(data, callback) {
    const encryptedNric = encryptStringWithPublicKey(data.nric);
    const url = `${ROOT_URL}/users/verifyOTPEmailCode`;
    return axios.post(url, {
        identifier: encryptedNric,
        otp: data.otp
    }).then((response) => {
        console.log('registerVerifyOTPEmail', response);
        callback(response.data, null);
        return {
            type: REGISTER_VERIFY_EMAIL_OTP_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('registerVerifyOTPEmail', error);
        callback(null, error);
        return {
            type: REGISTER_VERIFY_EMAIL_OTP_ERROR,
            payload: error
        };
    });
}

export function registerActivateAccount(data, callback) {
    const encryptedNric = encryptStringWithPublicKey(data.nric);
    const encryptedPassword = encryptStringWithPublicKey(data.password);
    const url = `${ROOT_URL}/users/activateaccount`;
    return axios.post(url, {
        identifier: encryptedNric,
        newPassword: encryptedPassword,
        email: data.email,
        contactNo: data.contactNo,
        contactNoCountryCode: data.contactNoCountryCode,
        mainTerms: 1,
        bankDetails: data.bankDetails
    }).then((response) => {
        console.log('registerActivateAccount', response);
        callback(response.data, null);
        return {
            type: REGISTER_ACTIVATE_ACCOUNT_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('registerActivateAccount', error);
        callback(null, error);
        return {
            type: REGISTER_ACTIVATE_ACCOUNT_ERROR,
            payload: error
        };
    });
}

export function submitResetPassword(data, callback) {
    const encryptedPassword = encryptStringWithPublicKey(data.password);
    const url = `${ROOT_URL}/users/resetPassword`;
    return axios.post(url, {
        token: data.token,
        newPassword: encryptedPassword
    }).then((response) => {
        console.log('submitResetPassword', response);
        callback(response.status, null);
        return {
            type: SUBMIT_RESET_PASSWORD_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('submitResetPassword', error);
        callback(null, error);
        return {
            type: SUBMIT_RESET_PASSWORD_ERROR,
            payload: error
        };
    });
}

export function submitRequestResetPassword(data, callback) {
    const url = `${ROOT_URL}/users/requestResetPasswordSuccess`;
    return axios.post(url, {
        email: data.email,
        captchaResponse: data.robot_id
    }).then((response) => {
        console.log('submitRequestResetPassword', response);
        callback(response.status, null);
        return {
            type: SUBMIT_REQ_RESET_PASSWORD_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('submitRequestResetPassword', error);
        callback(null, error);
        return {
            type: SUBMIT_REQ_RESET_PASSWORD_ERROR,
            payload: error
        };
    });
}

export function updateClinicFilterOptions(data, callback) {
    return {
        type: UPDATE_CLINIC_FILTER_OPTIONS,
        payload: data
    };
}

export function updateClinicSearchValue(data, callback) {
    return {
        type: UPDATE_SEARCH_CLINIC_VALUE,
        payload: data
    }
}

export function updateClinicSelection(data, callback) {
    return {
        type: UPDATE_CLINIC_SELECTION,
        payload: data
    };
}



export function getUserBenefitConfig({accessToken, userId, companyId}, callback) {
    let companyIdQuery = `?companyId=${companyId}`;

    const url = `${ROOT_URL}/benefits/${userId}${companyIdQuery}`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getUserBenefitConfig', response);
        return {
            type: GET_USER_BENEFIT_CONFIG_SUCCESS,
            payload: {
                userId,
                response
            }
        };
    }).catch((error) => {
        console.log('getUserBenefitConfig', error);
        return {
            type: GET_USER_BENEFIT_CONFIG_ERROR,
            payload: error
        }
    });
}

export function getUserProfileBenefitConfig({accessToken, userId, companyId}, callback) {
    let companyIdQuery = `?companyId=${companyId}`;

    const url = `${ROOT_URL}/profile/benefits/${userId}${companyIdQuery}`;
    console.log("url ", url)
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getUserBenefitConfig', response);
        return {
            type: GET_USER_BENEFIT_CONFIG_SUCCESS,
            payload: {
                userId,
                response
            }
        };
    }).catch((error) => {
        console.log('getUserBenefitConfig', error);
        return {
            type: GET_USER_BENEFIT_CONFIG_ERROR,
            payload: error
        }
    });
}

export function getUserNotifications(accessToken, callback) {
    const url = `${ROOT_URL}/notifications`;
    return axios({
        method: 'GET',
        url,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getUserNotifications', response);
        return {
            type: GET_USER_NOTIFICATIONS_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        const isTokenExpired = checkIfTokenHasExpired(error.errorCode);
        console.log('getUserNotifications', error, isTokenExpired);
        if (isTokenExpired && isTokenExpired === true) {
            return {
                type: UPDATE_USER_TOKEN_EXPIRED_ERROR,
                payload: null
            };
        }
        return {
            type: GET_USER_NOTIFICATIONS_ERROR,
            payload: error.message
        }
    });
}

export function getUserProfileNotifications(accessToken, callback) {
    console.log("check accesstoken", accessToken)
    const url = `${ROOT_URL}/appnotification/notifications`;
    return axios({
        method: 'GET',
        url,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getUserNotifications', response);
        return {
            type: GET_PROFILE_NOTIFICATIONS_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        return {
            type: GET_PROFILE_NOTIFICATIONS_ERROR,
            payload: error.message
        }
    });
}

export function getUserBenefitPlan({accessToken, userId, companyId}, callback) {
    let companyIdQuery = `?companyId=${companyId}`;

    const url = `${ROOT_URL}/benefitplans/${userId}${companyIdQuery}`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getUserBenefitPlan', response);
        return {
            type: GET_USER_BENEFIT_PLAN_SUCCESS,
            payload: {
                userId,
                response
            }
        };
    }).catch((error) => {
        console.log('getUserBenefitPlan', error);
        return {
            type: GET_USER_BENEFIT_PLAN_ERROR,
            payload: error
        }
    });
}

export function getUserProfileBenefitPlan({accessToken, userId, companyId}, callback) {
    let companyIdQuery = `?companyId=${companyId}`;

    const url = `${ROOT_URL}/profile/benefitplans/${userId}${companyIdQuery}`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getUserBenefitPlan', response);
        return {
            type: GET_USER_BENEFIT_PLAN_SUCCESS,
            payload: {
                userId,
                response
            }
        };
    }).catch((error) => {
        console.log('getUserBenefitPlan', error);
        return {
            type: GET_USER_BENEFIT_PLAN_ERROR,
            payload: error
        }
    });
}

export function getElogConfigQuestions(nric, accessToken, callback) {
    const url = `${ROOT_URL}/externalapi/elog/getElogConfigQuestions`;
    return axios({
        method: 'POST',
        url,
        data: {
            nric
        },
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getElogConfigQuestions', response);
        return {
            type: GET_APP_CFG_ELOG_QUESTIONS_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getElogConfigQuestions', error);
        return {
            type: GET_APP_CFG_ELOG_QUESTIONS_ERROR,
            payload: error
        };
    });
}

export function getElogList(nric, accessToken, companyId, callback) {
    const encryptedNric = encryptStringWithElogPublicKey(nric);
    let companyIdQuery = `?companyId=${companyId}`;

    // console.log(encryptStringWithElogPublicKey('s2220003e'));
    // console.log('here', encryptedNric);
    // const url = `${ROOT_ELOG_URL}/api/v1/web_portal/lists`;
    const url = `${ROOT_URL}/externalapi/elog/getElogList${companyIdQuery}`;
    return axios({
        method: 'POST',
        url,
        data: qs.stringify({
            encryptedNric
        }),
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getElogList', response);
        return {
            type: GET_ELOG_LIST_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getElogList', error);
        return {
            type: GET_ELOG_LIST_ERROR,
            payload: error
        };
    });
}

export function getMarketList(nric, accessToken, callback) {
    const encryptedNric = encryptStringWithElogPublicKey(nric);
    // console.log(encryptStringWithElogPublicKey('s2220003e'));
    // console.log('here', encryptedNric);
    // const url = `${ROOT_ELOG_URL}/api/v1/web_portal/lists`;
    const url = `${ROOT_URL}/externalapi/getElogList`;
    return axios({
        method: 'POST',
        url,
        data: qs.stringify({
            encryptedNric
        }),
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getElogList', response);
        return {
            type: GET_ELOG_LIST_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getElogList', error);
        return {
            type: GET_ELOG_LIST_ERROR,
            payload: error
        };
    });
}

export function submitElog({data, attachments, accessToken}, callback) {
    // setup form data;
    let companyIdQuery = `?companyId=${data.companyId}`;
    let formData = new FormData();
    Object.keys(data).forEach(key => {
        let value = data[key];
        //use key and value here
        if (value) {
            // console.log(key, ' - ', value);
            formData.append(key, value);
        }
    });
    for (let i = 0; i < attachments.length; i++) {
        formData.append('documents', attachments[i]);
    }
    // const url = `${ROOT_ELOG_URL}/api/v1/web_portal/create_eLoG_files`;
    const url = `${ROOT_URL}/externalapi/submitElog${companyIdQuery}`;
    // console.log(qs.stringify({
    //     ...data, documents: attachments
    // }));
    return axios({
        method: 'POST',
        url,
        data: formData,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('submitElog', response);
        callback(response.data.data, null);
        return {
            type: SUBMIT_ELOG_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('submitElog', error);
        callback(null, error);
        return {
            type: SUBMIT_ELOG_ERROR,
            payload: error
        };
    });
}

export function submitElog2({data, attachments, accessToken}, callback) {
    // setup form data;
    let companyIdQuery = `?companyId=${data.companyId}`;
    let formData = new FormData();
    Object.keys(data).forEach(key => {
        let value = data[key];
        //use key and value here
        if (value) {
            // console.log(key, ' - ', value);
            formData.append(key, value);
        }
    });
    for (let i = 0; i < attachments.length; i++) {
        formData.append('documents', attachments[i]);
    }
    // const url = `${ROOT_ELOG_URL}/api/v1/web_portal/create_eLoG_files`;
    const url = `${ROOT_URL}/externalapi/elog/submitElog${companyIdQuery}`;
    // console.log(qs.stringify({
    //     ...data, documents: attachments
    // }));
    return axios({
        method: 'POST',
        url,
        data: formData,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('submitElog', response);
        callback(response.data.data, null);
        return {
            type: SUBMIT_ELOG_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('submitElog', error);
        callback(null, error);
        return {
            type: SUBMIT_ELOG_ERROR,
            payload: error
        };
    });
}

export function getElogPdfUrl({filename, policyNo, eLoG_ID, accessToken}, callback) {
    const url = `${ROOT_URL}/externalapi/elog/getElogPdfUrl`;
    // const url = `${ROOT_ELOG_URL}/api/v1/web_portal/generate_PDF_URL`;
    return axios({
        method: 'POST',
        url,
        data: qs.stringify({
            filename,
            policyNo,
            eLoG_ID
        }),
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getElogPdfUrl', response);
        callback(response, null);
        return {
            type: GET_ELOG_PDF_URL_SUCCESS,
            payload: {
                response,
                eLoG_ID
            }
        };
    }).catch((error) => {
        console.log('getElogPdfUrl', error);
        callback(null, error);
        return {
            type: GET_ELOG_PDF_URL_ERROR,
            payload: error
        };
    });
}
 
export function getSystemAdminClients({ accessToken, searchPage = null, searchMax = null, params = {} }, callback) {
    const url =`${ROOT_URL}/sysadmin/clients?${qs.stringify({
        searchPage,
        searchMax,
        ...params
    })}`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: { 'Accesstoken' : accessToken }
    }).then((response) => {
        console.log('getSystemAdminClients', response);
        callback(response, null);
        return {
            type: GET_SYSTEM_ADMIN_CLIENTS_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getSystemAdminClients', error);
        callback(null, error);
        return {
            type: GET_SYSTEM_ADMIN_CLIENTS_ERROR,
            payload: error.message
        }
    });
}

export function getSystemAdminExcludedClinics(accessToken, callback) {
    const url = `${ROOT_URL}/sysadmin/excludedclinics`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getSystemAdminExcludedClinics', response);
        callback(response, null);
        return {
            type: GET_SYSTEM_ADMIN_EXCLUDED_CLINICS_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getSystemAdminExcludedClinics', error);
        callback(null, error);
        return {
            type: GET_SYSTEM_ADMIN_EXCLUDED_CLINICS_ERROR,
            payload: error.message
        }
    });
}

export function submitSystemAdminCreateAdmin({accessToken, data}, callback) {
    // const url =`${ROOT_URL}/sysadmin/admin/setup/`;
    const url =`${ROOT_URL}/sysadmin/admin/setup/register`;

    console.log(data)
    // data.password = encryptStringWithPublicKey(data.password)
    return axios({
        method: 'POST',
        url,
        data: data,
        headers: { 'Accesstoken': accessToken }
    }).then((response) => {
        console.log('submitSystemAdminCreateAdmin', response);
        callback(response.data, null);
        return {
            type: SUBMIT_SYSTEM_ADMIN_CREATE_USER_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('submitSystemAdminCreateAdmin', error);
        callback(null, error);
        return {
            type: SUBMIT_SYSTEM_ADMIN_CREATE_USER_ERROR,
            payload: error.message
        }
    });
}

export function submitSystemAdminUpdateAdmin({accessToken, userId, data}, callback) {
    const url =`${ROOT_URL}/sysadmin/admin/setup/${userId}`;
    if (data.password && data.password !== "") {
        data.password = encryptStringWithPublicKey(data.password)
    }
    return axios({
        method: 'PUT',
        url,
        data,
        headers: { 'Accesstoken' : accessToken }
    }).then((response) => {
        console.log('sysadminUpdateAdmin', response);
        callback(response.data, null);
        return {
            type: SUBMIT_SYSTEM_ADMIN_UPDATE_USER_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('sysadminUpdateAdmin', error);
        callback(null, error);
        return {
            type: SUBMIT_SYSTEM_ADMIN_UPDATE_USER_SUCCESS,
            payload: error.message
        }
    });
}

export function submitSystemAdminUpdateAdminStatus({accesstoken, userId, data}, callback) {
    const url =`${ROOT_URL}/sysadmin/admin/status/${userId}`;
    console.log(accesstoken, userId, data)
    return axios({
        method: 'PUT',
        url,
        data,
        headers: { 'Accesstoken' : accesstoken }
    }).then((response) => {
        console.log('sysadminUpdateAdminStatus', response);
        callback(response.data, null);
        return {
            type: SUBMIT_SYSTEM_ADMIN_UPDATE_USER_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('sysadminUpdateAdminStatus', error);
        callback(null, error);
        return {
            type: SUBMIT_SYSTEM_ADMIN_UPDATE_USER_SUCCESS,
            payload: error.message
        }
    });
}

export function submitSystemAdminDelete({accesstoken, userId}, callback) {
    const url =`${ROOT_URL}/sysadmin/admin/setup/${userId}`;
    console.log(accesstoken, userId)
    return axios({
        method: 'DELETE',
        url,
        headers: { 'Accesstoken' : accesstoken }
    }).then((response) => {
        console.log('submitSystemAdminDelete', response);
        callback(response.data, null);
        return {
            type: SUBMIT_SYSTEM_ADMIN_UPDATE_USER_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('submitSystemAdminDelete', error);
        callback(null, error);
        return {
            type: SUBMIT_SYSTEM_ADMIN_UPDATE_USER_SUCCESS,
            payload: error.message
        }
    });
}

export function getSystemAdminUsers({accessToken, searchPage, searchMax, params}, callback) {
    const url = `${ROOT_URL}/sysadmin/users?${qs.stringify({
        searchPage,
        searchMax,
        ...params
    })}`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getSystemAdminUsers', response);
        callback(response, null);
        return {
            type: GET_SYSTEM_ADMIN_USERS_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getSystemAdminUsers', error);
        callback(null, error);
        return {
            type: GET_SYSTEM_ADMIN_USERS_ERROR,
            payload: error.message
        }
    });
}

export function getSystemAdminUserDetail({accessToken, userId}, callback) {
    const url = `${ROOT_URL}/sysadmin/users/detail?${qs.stringify({ _id: userId })}`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getSystemAdminUserDetail', response)
        callback(response, null);
        return {
            type: GET_SYSTEM_ADMIN_USER_DETAIL_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getSystemAdminUserDetail', error)
        callback(null, error);
        return {
            type: GET_SYSTEM_ADMIN_USER_DETAIL_ERROR,
            payload: error.message
        };
    });
}

export function submitSystemAdminUpdateDefaultCompany({accessToken, userId, data}, callback) {
    const url =`${ROOT_URL}/sysadmin/users/setupcompany/${userId}`;
    return axios({
        method: 'PUT',
        url,
        data,
        headers: { 'Accesstoken' : accessToken }
    }).then((response) => {
        console.log('submitSystemAdminUpdateDefaultCompany', response);
        callback(response.data, null);
        return {
            type: SUBMIT_SYSTEM_ADMIN_UPDATE_USER_DEFAULT_COMPANY_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('sysadminUpdateUser', error);
        callback(null, error);
        return {
            type: SUBMIT_SYSTEM_ADMIN_UPDATE_USER_DEFAULT_COMPANY_SUCCESS,
            payload: error.message
        }
    });
}

export function submitSystemAdminCreateUser({accessToken, data}, callback) {
    const url = `${ROOT_URL}/sysadmin/users/setup/`;
    return axios({
        method: 'POST',
        url,
        data: data,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('submitSystemAdminCreateUser', response);
        callback(response.data, null);
        return {
            type: SUBMIT_SYSTEM_ADMIN_CREATE_USER_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('submitSystemAdminCreateUser', error);
        callback(null, error);
        return {
            type: SUBMIT_SYSTEM_ADMIN_CREATE_USER_ERROR,
            payload: error.message
        }
    });
}


export function submitSystemAdminUpdateUser({accessToken, userId, data}, callback) {
    const url = `${ROOT_URL}/sysadmin/users/setup/${userId}`;
    return axios({
        method: 'PUT',
        url,
        data,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('sysadminUpdateUser', response);
        callback(response.data, null);
        return {
            type: SUBMIT_SYSTEM_ADMIN_UPDATE_USER_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('sysadminUpdateUser', error);
        callback(null, error);
        return {
            type: SUBMIT_SYSTEM_ADMIN_UPDATE_USER_SUCCESS,
            payload: error.message
        }
    });
}

export function submitSystemAdminCreateClient({accessToken, data}, callback) {
    const url = `${ROOT_URL}/sysadmin/client`;
    return axios({
        method: 'POST',
        url,
        data: data,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('submitSystemAdminCreateClient', response);
        callback(response.data, null);
        return {
            type: SUBMIT_SYSTEM_ADMIN_CREATE_CLIENT_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('submitSystemAdminCreateClient', error);
        callback(null, error);
        return {
            type: SUBMIT_SYSTEM_ADMIN_CREATE_CLIENT_ERROR,
            payload: error.message
        }
    });
}

export function submitSystemAdminCreateExcludedClinic({accessToken, data}, callback) {
    const url = `${ROOT_URL}/sysadmin/excludedclinic`;
    return axios({
        method: 'POST',
        url,
        data: data,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('submitSystemAdminCreateExcludedClinic', response);
        callback(response.data, null);
        return {
            type: SUBMIT_SYSTEM_ADMIN_CREATE_EXCLUDED_CLINIC_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('submitSystemAdminCreateExcludedClinic', error);
        callback(null, error);
        return {
            type: SUBMIT_SYSTEM_ADMIN_CREATE_EXCLUDED_CLINIC_ERROR,
            payload: error.message
        }
    });
}

export function submitSystemAdminDeleteExcludedClinic({accessToken, id}, callback) {
    const url = `${ROOT_URL}/sysadmin/excludedclinic/${id}`;
    return axios({
        method: 'DELETE',
        url,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('submitSystemAdminDeleteExcludedClinic', response);
        callback(response.data, null);
        return {
            type: SUBMIT_SYSTEM_ADMIN_DELETE_EXCLUDED_CLINIC_SUCCESS,
            payload: response,
            id
        };
    }).catch((error) => {
        console.log('submitSystemAdminDeleteExcludedClinic', error);
        callback(null, error);
        return {
            type: SUBMIT_SYSTEM_ADMIN_DELETE_EXCLUDED_CLINIC_ERROR,
            payload: error.message
        }
    });
}

export function submitSystemAdminUpdateClient({accessToken, clientId, data}, callback) {
    const url = `${ROOT_URL}/sysadmin/client/${clientId}`;
    return axios({
        method: 'PUT',
        url,
        data: data,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('submitSystemAdminUpdateClient', response);
        callback(response.data, null);
        return {
            type: SUBMIT_SYSTEM_ADMIN_UPDATE_CLIENT_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('submitSystemAdminUpdateClient', error);
        callback(null, error);
        return {
            type: SUBMIT_SYSTEM_ADMIN_UPDATE_CLIENT_ERROR,
            payload: error.message
        }
    });
}

export function submitSystemAdminCreateUsersUpload({accessToken, data}, callback) {
    const url = `${ROOT_URL}/sysadmin/upload/users`;
    return axios({
        method: 'POST',
        url,
        data: data,
        timeout: 600000, //10 minutes
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('submitSystemAdminCreateUsersUpload', response);
        callback(response.data, null);
        return {
            type: SUBMIT_SYSTEM_ADMIN_UPLOAD_USERS_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('submitSystemAdminCreateUsersUpload', error);
        callback(null, error);
        return {
            type: SUBMIT_SYSTEM_ADMIN_UPLOAD_USERS_ERROR,
            payload: error.message
        }
    });
}

export function submitSystemAdminUserBankAccount({accessToken, data}, callback) {
    const url = `${ROOT_URL}/sysadmin/users/proposedBank/${data.userId}`;
    return axios({
        method: 'PATCH',
        url,
        data,
        timeout: 600000, //10 minutes
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('submitSystemAdminUserBankAccount success', response);
        callback(response.data, null);
        return {
            type: SUBMIT_SYSTEM_ADMIN_USER_BANK_ACCOUNT_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('submitSystemAdminUserBankAccount error', error);
        callback(null, error);
        return {
            type: SUBMIT_SYSTEM_ADMIN_USER_BANK_ACCOUNT_ERROR,
            payload: error.message
        }
    });
}

export function deleteProposedUserBankAccount({accessToken, userId}, callback) {
    const url = `${ROOT_URL}/sysadmin/users/proposedBank/${userId}`;
    return axios({
        method: 'DELETE',
        url,
        timeout: 600000, //10 minutes
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('deleteProposedUserBankAccount success', response);
        callback(response.data, null);
        return {
            type: DELETE_PROPOSED_BANK_ACCOUNT_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('deleteProposedUserBankAccount error', error);
        callback(null, error);
        return {
            type: DELETE_PROPOSED_BANK_ACCOUNT_ERROR,
            payload: error.message
        };
    });
}

export function submitSystemAdminUserVerifyBankAccount({accessToken, data}, callback) {
    const url = `${ROOT_URL}/sysadmin/users/verifyProposedBank/${data.userId}`;
    return axios({
        method: 'PATCH',
        url,
        data,
        timeout: 600000, //10 minutes
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('submitSystemAdminUserVerifyBankAccount success', response);
        callback(response.data, null);
        return {
            type: SUBMIT_SYSTEM_ADMIN_VERIFY_BANK_ACCOUNT_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('submitSystemAdminUserVerifyBankAccount error', error);
        callback(null, error);
        return {
            type: SUBMIT_SYSTEM_ADMIN_VERIFY_BANK_ACCOUNT_ERROR,
            payload: error.message
        };
    });
}

export function getSystemAdminHrClaimsListData(accessToken, callback) {
    const url = `${ROOT_URL}/hradmin/hrclaims`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getSystemAdminHrClaimsListData', response);
        return {
            type: GET_SYSTEM_ADMIN_HR_CLAIMS_LIST_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getSystemAdminHrClaimsListData', error);
        return {
            type: UPDATE_API_ERROR,
            payload: error.message
        }
    });
}

export function getUserConfigBenefitRequest() {
    return {
        type: GET_USER_CONFIG_BENEFIT_REQUEST
    }
}

export function getUserConfigBenefit({accessToken, companyId}, callback) {
    store.dispatch(getUserConfigBenefitRequest())

    let companyIdQuery = `?companyId=${companyId}`;
    const url = `${ROOT_URL}/config/benefits${companyIdQuery}`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getUserConfigBenefit', response);
        return {
            type: GET_USER_CONFIG_BENEFIT_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getUserConfigBenefit', error);
        return {
            type: GET_USER_CONFIG_BENEFIT_ERROR,
            payload: error
        }
    });
}

export function checkEcardAllow({accessToken, companyId}, callback) {
    let companyIdQuery = `?companyId=${companyId}`;
    const url = `${ROOT_URL}/ecard/check`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('checkEcardAllow no error', response);
        return {
            type: CHECK_ECARD_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('checkEcardAllow error', error);
        return {
            type: CHECK_ECARD_ERROR,
            payload: error
        }
    });
}

export function getUserPlanConfigBenefit({accessToken, companyId}, callback) {
    let companyIdQuery = `?companyId=${companyId}`;

    const url = `${ROOT_URL}/config/benefits/myplan${companyIdQuery}`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getUserPlanConfigBenefit', response);
        return {
            type: GET_USER_CONFIG_BENEFIT_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getUserPlanConfigBenefit', error);
        return {
            type: GET_USER_CONFIG_BENEFIT_ERROR,
            payload: error
        }
    });
}

export function getClaimUserPlanConfigBenefit({accessToken, companyId}, callback) {
    let companyIdQuery = `?companyId=${companyId}`;

    const url = `${ROOT_URL}/claims/config/benefits${companyIdQuery}`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getClaimUserPlanConfigBenefit', response);
        return {
            type: GET_USER_CONFIG_BENEFIT_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getClaimUserPlanConfigBenefit', error);
        return {
            type: GET_USER_CONFIG_BENEFIT_ERROR,
            payload: error
        }
    });
}

export function getProfileConfigBenefit({accessToken, companyId}, callback) {
    let companyIdQuery = `?companyId=${companyId}`;

    const url = `${ROOT_URL}/profile/config/benefits${companyIdQuery}`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getUserPlanConfigBenefit', response);
        return {
            type: GET_USER_CONFIG_BENEFIT_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getUserPlanConfigBenefit', error);
        return {
            type: GET_USER_CONFIG_BENEFIT_ERROR,
            payload: error
        }
    });
}

/**
 * START MHC ARTICLES
 */

export function getMHCArticlesBannerListHomepage(accessToken) {
    const url = `${ROOT_URL}/externalapi/getMHCArticlesBannerList/homepage`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getMHCArticlesBannerList', response.data);
        return {
            type: GET_ARTICLES_BANNER_LIST_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getMHCArticlesBannerList', error);
        return {
            type: GET_ARTICLES_BANNER_LIST_ERROR,
            payload: error
        }
    });
}

export function getMHCArticlesBannerList(accessToken) {
    const url = `${ROOT_URL}/externalapi/getMHCArticlesBannerList`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getMHCArticlesBannerList', response.data);
        return {
            type: GET_ARTICLES_BANNER_LIST_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getMHCArticlesBannerList', error);
        return {
            type: GET_ARTICLES_BANNER_LIST_ERROR,
            payload: error
        }
    });
}

export function getMHCArticlesFullList(accessToken) {
    const url = `${ROOT_URL}/externalapi/getMHCArticlesFullList`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getMHCArticlesFullList', response.data);
        return {
            type: GET_ARTICLES_FULL_LIST_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getMHCArticlesFullList', error);
        return {
            type: GET_ARTICLES_FULL_LIST_ERROR,
            payload: error
        }
    });
}

export function getPageMHCArticlesFullList(accessToken) {
    const url = `${ROOT_URL}/externalapi/healtharticle/getMHCArticlesFullList`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getMHCArticlesFullList', response.data);
        return {
            type: GET_ARTICLES_FULL_LIST_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getMHCArticlesFullList', error);
        return {
            type: GET_ARTICLES_FULL_LIST_ERROR,
            payload: error
        }
    });
}

export function getPageMHCYoutubeVideosFullList(accessToken) {
    const url = `${ROOT_URL}/externalapi/healtharticle/getMHCYoutubeVideosFullList`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getMHCYoutubeVideosFullList', response.data);
        return {
            type: GET_ARTICLES_VIDEOS_FULL_LIST_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getMHCYoutubeVideosFullList', error);
        return {
            type: GET_ARTICLES_VIDEOS_FULL_LIST_ERROR,
            payload: error
        }
    });
}

export function getMHCYoutubeVideosFullList(accessToken) {
    const url = `${ROOT_URL}/externalapi/getMHCYoutubeVideosFullList`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getMHCYoutubeVideosFullList', response.data);
        return {
            type: GET_ARTICLES_VIDEOS_FULL_LIST_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getMHCYoutubeVideosFullList', error);
        return {
            type: GET_ARTICLES_VIDEOS_FULL_LIST_ERROR,
            payload: error
        }
    });
}

export function getMHCYoutubeVideosDetail(playlistId, accessToken) {
    const url = `${ROOT_URL}/externalapi/healtharticle/getMHCYoutubeVideosDetail/${playlistId}`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getMHCYoutubeVideosDetail', response.data);
        return {
            type: GET_ARTICLES_VIDEOS_DETAIL_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getMHCYoutubeVideosDetail', error);
        return {
            type: GET_ARTICLES_VIDEOS_DETAIL_ERROR,
            payload: error
        }
    });
}

/**
 * START MHC Rewards
 */

export function getMHCRewardsCategoryList(accessToken) {
    const url = `${ROOT_URL}/externalapi/rewards/category`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getMHCRewardsCategoryList-success', response.data);
        return {
            type: GET_REWARDS_CATEGORY_LIST_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getMHCRewardsCategoryList-error', error);
        return {
            type: GET_REWARDS_CATEGORY_LIST_ERROR,
            payload: error
        }
    });
}


export function getMHCRewardsListByCategory(accessToken, category) {
    const url = `${ROOT_URL}/externalapi/rewards/category/${category}`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getMHCRewardsListByCategory-success', response.data);
        return {
            type: GET_REWARDS_LIST_BY_CATEGORY_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getMHCRewardsListByCategory-error', error);
        return {
            type: GET_REWARDS_LIST_BY_CATEGORY_ERROR,
            payload: error
        }
    });
}

export function getMHCRewardsDetail(accessToken, pk) {
    const url = `${ROOT_URL}/externalapi/rewards/detail/${pk}`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getMHCRewardsDetail-success', response.data);
        return {
            type: GET_REWARDS_DETAILS_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getMHCRewardsDetail-error', error);
        return {
            type: GET_REWARDS_DETAILS_ERROR,
            payload: error
        }
    });
}

export function redeemMHCRewards(accessToken, pk) {
    const url = `${ROOT_URL}/externalapi/rewards/redeemReward/${pk}`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('redeemMHCRewards-success', response.data);
        return {
            type: REDEEM_REWARDS_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('redeemMHCRewards-error', error);
        return {
            type: REDEEM_REWARDS_ERROR,
            payload: error.message
        }
    });
}

/**
 * HR Admin Functions **START**
 */

export function getHradminEmployeeListData(accessToken, callback) {
    const url = `${ROOT_URL}/hradmin/employees`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getHradminEmployeeListData', response);
        return {
            type: GET_HRADMIN_EMPLOYEE_LIST_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getHradminEmployeeListData', error);
        return {
            type: UPDATE_API_ERROR,
            payload: error.message
        }
    });
}

export function getHradminEmployeeClaimsListData({userId, accessToken}, callback) {
    const url = `${ROOT_URL}/hradmin/employee/${userId}/claimList`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getHradminEmployeeClaimsListData', response);
        return {
            type: GET_HRADMIN_EMPLOYEE_CLAIMS_LIST_SUCCESS,
            payload: {
                response,
                selectedUserId: userId
            }
        };
    }).catch((error) => {
        console.log('getHradminEmployeeClaimsListData', error);
        return {
            type: UPDATE_API_ERROR,
            payload: error.message
        }
    });
}

export function getHradminEmployeeOutpatientClaimData({transactionNo, userId, accessToken}, callback) {
    const url = `${ROOT_URL}/hradmin/employee/${userId}/claim/out/${transactionNo}`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getHradminEmployeeOutpatientClaimData', response);
        return {
            type: GET_HRADMIN_EMPLOYEE_OUTPATIENT_CLAIM_DATA_SUCCESS,
            payload: {
                response,
                selectedUserId: userId,
                selectedClaimToView: transactionNo,
            }
        };
    }).catch((error) => {
        console.log('getHradminEmployeeOutpatientClaimData', error);
        return {
            type: UPDATE_API_ERROR,
            payload: error.message
        }
    });
}

export function getHradminEmployeeInpatientClaimData({transactionNo, userId, accessToken}, callback) {
    const url = `${ROOT_URL}/hradmin/employee/${userId}/claim/inp/${transactionNo}`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getHradminEmployeeInpatientClaimData', response);
        return {
            type: GET_HRADMIN_EMPLOYEE_INPATIENT_CLAIM_DATA_SUCCESS,
            payload: {
                response,
                selectedUserId: userId,
                selectedClaimToView: transactionNo,
            }
        };
    }).catch((error) => {
        console.log('getHradminEmployeeInpatientClaimData', error);
        return {
            type: UPDATE_API_ERROR,
            payload: error.message
        }
    });
}

export function submitHradminEmployeeHrClaimData({data, attachments, userId, accessToken}, callback) {
    // setup form data;
    let formData = new FormData();
    Object.keys(data).forEach(key => {
        let value = data[key];
        if (value) {
            formData.append(key, value);
        }
    });
    for (let i = 0; i < attachments.length; i++) {
        formData.append('attachment', attachments[i]);
    }
    const url = `${ROOT_URL}/hradmin/employee/${userId}/claim`;
    return axios({
        method: 'POST',
        url,
        data: formData,
        headers: {
            'Accesstoken': accessToken,
            'Content-Type': 'multipart/form-data'
        }
    }).then((response) => {
        console.log('submitHradminEmployeeHrClaimData', response);
        callback(response, null);
        return {
            type: SUBMIT_HRADMIN_EMPLOYEE_HR_CLAIM_DATA_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('submitHradminEmployeeHrClaimData', error);
        callback(null, error);
        return {
            type: UPDATE_API_ERROR,
            payload: error.message
        }
    });
}

export function submitHradminEmployeeUpdateAccess({data, userId, accessToken}, callback) {
    const url = `${ROOT_URL}/hradmin/employee/${userId}/access`;
    return axios({
        method: 'POST',
        url,
        data,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('submitHradminEmployeeUpdateAccess', response);
        callback(response, null);
        return {
            type: SUBMIT_HRADMIN_EMPLOYEE_UPDATE_ACCESS_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('submitHradminEmployeeUpdateAccess', error);
        callback(null, error);
        return {
            type: UPDATE_API_ERROR,
            payload: error.message
        }
    });
}

export function getHradminMhcInsightsURL({accessToken}, callback) {
    const url = `${ROOT_URL}/hradmin/mhcinsights/generateURL`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('getHradminMhcInsightsURL', response);
        return {
            type: GET_HRADMIN_MHC_INSIGHTS_URL_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getHradminMhcInsightsURL', error);
        return {
            type: UPDATE_API_ERROR,
            payload: error.message
        }
    });
}

// HR Admin Functions ***END***

export function getAppLaunchConfigFromMHC() {
    const url = `${ROOT_URL}/externalapi/getAppLaunchConfigFromMHC`;
    return axios({
        method: 'GET',
        url,
        data: {},
    }).then((response) => {
        //console.log('getAppLaunchConfigFromMHC', response.data);
        return {
            type: GET_APPLAUNCH_CONFIG_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        //console.log('getAppLaunchConfigFromMHC', error);
        return {
            type: GET_APPLAUNCH_CONFIG_ERROR,
            payload: error.message
        }
    });
}

export function resetUserData() {
    return {
        type: RESET_USER_DATA
    }
}

export function showOTPModal() {
    return {
        type: VERIFY_LOGIN_EMAIL_OTP_REQUEST
    }
}

export function setRemindUpdatePassword(isTrue) {
    return {
        type: SET_REMIND_UPDATE_PASSWORD,
        payload: isTrue
    }
}

export function getAllInpatientClaimBySysAdmin(accessToken, params, callback) {
    return async function(dispatch){
        try{
            dispatch({type: GET_ALL_INPATIENT_CLAIM_BY_SYSADMIN_LOADING});
            const url = `${ROOT_URL}/sysadmin/inpatient`;
            let result = await axios({
                method: 'GET',
                url,
                params: params,
                headers: { 'Accesstoken' : accessToken }
            });
            dispatch({
                type: GET_ALL_INPATIENT_CLAIM_BY_SYSADMIN_SUCCESS,
                payload: result.data
            });
            if(typeof callback === "function") callback(result.data, null);
        }catch(err){
            console.error(err);
            dispatch({
                type: GET_ALL_INPATIENT_CLAIM_BY_SYSADMIN_ERROR,
                payload: err
            });
            if(typeof callback === "function") callback(null, err);
        }
    }
}

export function getDetailInpatientClaimBySysAdmin(accessToken, params, callback) {
    return async function(dispatch){
        try{
            dispatch({type: GET_DETAIL_INPATIENT_CLAIM_BY_SYSADMIN_LOADING});
            const url = `${ROOT_URL}/sysadmin/inpatient/detail`;
            let result = await axios({
                method: 'GET',
                url,
                params: params,
                headers: { 'Accesstoken' : accessToken }
            });
            dispatch({
                type: GET_DETAIL_INPATIENT_CLAIM_BY_SYSADMIN_SUCCESS,
                payload: result.data
            });
        }catch(err){
            console.error(err);
            dispatch({
                type: GET_DETAIL_INPATIENT_CLAIM_BY_SYSADMIN_ERROR,
                payload: err
            });
        }
    }
}

export function editInpatientClaimBySysAdmin(accessToken, data, callback){
    return async function(dispatch){
        try{
            dispatch({type: EDIT_INPATIENT_CLAIM_BY_SYSADMIN_LOADING});
            const url = `${ROOT_URL}/sysadmin/inpatient`;
            let result = await axios({
                method: 'PUT',
                url,
                data,
                headers: { 'Accesstoken' : accessToken }
            });
            dispatch({
                type: EDIT_INPATIENT_CLAIM_BY_SYSADMIN_SUCCESS,
                payload: result.data
            });
            if(typeof callback === "function") callback(result.data, null);
        }catch(err){
            console.error(err);
            dispatch({
                type: EDIT_INPATIENT_CLAIM_BY_SYSADMIN_ERROR,
                payload: err
            });
            if(typeof callback === "function") callback(null, err);
        }
    }
}

export function getAllOutpatientClaimBySysAdmin(accessToken, params, callback) {
    return async function(dispatch){
        try{
            dispatch({type: GET_ALL_OUTPATIENT_CLAIM_BY_SYSADMIN_LOADING});
            const url = `${ROOT_URL}/sysadmin/outpatient`;
            let result = await axios({
                method: 'GET',
                url,
                params: params,
                headers: { 'Accesstoken' : accessToken }
            });
            dispatch({
                type: GET_ALL_OUTPATIENT_CLAIM_BY_SYSADMIN_SUCCESS,
                payload: result.data
            });
            if(callback)callback(result.data, null);
        }catch(err){
            console.error(err);
            dispatch({
                type: GET_ALL_OUTPATIENT_CLAIM_BY_SYSADMIN_ERROR,
                payload: err
            });
            if(callback)callback(null, err);
        }
    }
}

export function getDetailOutpatientClaimBySysAdmin(accessToken, params, callback) {
    return async function(dispatch){
        try{
            dispatch({type: GET_DETAIL_OUTPATIENT_CLAIM_BY_SYSADMIN_LOADING});
            const url = `${ROOT_URL}/sysadmin/outpatient/detail`;
            let result = await axios({
                method: 'GET',
                url,
                params: params,
                headers: { 'Accesstoken' : accessToken }
            });
            dispatch({
                type: GET_DETAIL_OUTPATIENT_CLAIM_BY_SYSADMIN_SUCCESS,
                payload: result.data
            });
        }catch(err){
            console.error(err);
            dispatch({
                type: GET_DETAIL_OUTPATIENT_CLAIM_BY_SYSADMIN_ERROR,
                payload: err
            });
        }
    }
}

export function editOutpatientClaimBySysAdmin(accessToken, data, callback){
    return async function(dispatch){
        try{
            dispatch({type: EDIT_OUTPATIENT_CLAIM_BY_SYSADMIN_LOADING});
            const url = `${ROOT_URL}/sysadmin/outpatient`;
            let result = await axios({
                method: 'PUT',
                url,
                data,
                headers: { 'Accesstoken' : accessToken }
            });
            dispatch({
                type: EDIT_OUTPATIENT_CLAIM_BY_SYSADMIN_SUCCESS,
                payload: result.data
            });
            if(typeof callback === "function") callback(result.data, null);
        }catch(err){
            console.error(err);
            dispatch({
                type: EDIT_OUTPATIENT_CLAIM_BY_SYSADMIN_ERROR,
                payload: err
            });
            if(typeof callback === "function") callback(null, err);
        }
    }
}

export function getAuditUserAction({ id, searchPage, searchMax,params,accessToken }, callback) {
    return async function(dispatch) {
      try { 
        dispatch({ type: GET_AUDIT_USER_REQUEST });
        const url = `${ROOT_URL}/sysadmin/users/audit/${id}?${qs.stringify({
          searchPage,
          searchMax, 
          ...params
        })}`;  
        let result = await axios({
          method: "GET",
          url,
          params: params,
          headers: { Accesstoken: accessToken }
        }); 
        dispatch({
          type: GET_AUDIT_USER_SUCCESS,
          payload: {
            result:result.data.result,
            pagination:result.data.pagination
          }
        });
         
      } catch (err) { 
        dispatch({
          type: GET_AUDIT_USER_FAILURE,
          payload: err
        }); 
      }
    };
  }


export function appLaunchRequest() {
    return {
        type: APP_LAUNCH_REQUEST
    };
}

export function appLaunchSuccess(appLaunch, appLaunchExtra) {
    return {
        type: APP_LAUNCH_SUCCESS,
        appLaunch,
        appLaunchExtra
    };
}

export function appLaunchFailure(error) {
    return {
        type: APP_LAUNCH_FAILURE,
        error
    };
}

export function disableShowCovidMsg (){  
    return {
        type: DISABLE_COVID_MSG
    }
}

export function enableShowCovidMsg (){
    return {
        type: ENABLE_COVID_MSG
    }
}


export function getAppLaunchAction() {
    return (dispatch, getState) => { 

        let urlString = APPLAUNCH_URL 

        return fetch(urlString, {
            method: 'GET'
        }).then(response => {
            if (response.ok) { 
                return response.json().then(json => { 
                    let appLaunch = json['appLaunch']; 
                    dispatch(appLaunchSuccess(appLaunch.launchMessage, appLaunch)); 
                });
            } else {
                console.log(response,'=====>>>>RESPONSE NOT OKE')
                // LogFetchResponseError(arguments.callee, response); 
                // let mhcError = new MHCError();
                // return mhcError.setResponse(response, 'App Launch Failed').then(() => { 
                // dispatch(appLaunchFailure(mhcError));
                // })
            }
        }).catch(error => {
            console.log(error,'====>>>ERROR')
            // LogFetchError(arguments.callee, error) 
            // let mhcError = new MHCError(500, FETCH_EXCEPTION_ERROR_MSG, 'App Launch Failed'); 
            // dispatch(appLaunchFailure(mhcError)); 
        });
    };
}

export function getAllJob(accessToken, params, callback) {
    return async function(dispatch){
        try{
            const url = `${ROOT_URL}/sysadmin/jobs`;
            let result = await axios({
                                     method: 'GET',
                                     url,
                                     params: params,
                                     headers: { 'Accesstoken' : accessToken }
                                     });
            if(typeof callback === 'function') callback(result);
        }catch(err){
            console.error(err);
        }
    }
}

export function setCompanyClaimOption(companyId){
    const action = {
        type: SET_COMPANY_CLAIM_OPTIONS_SUCCESS,
        companyId
      }
    store.dispatch(action)
}

export function setVisitDateClaimOption(visitDate){
    const action = {
        type: SET_VISIT_DATE_CLAIM_OPTIONS_SUCCESS,
        visitDate
      }
    store.dispatch(action)
}

export function setClaimantClaimOption(claimantId){
    const action = {
        type: SET_CLAIMANT_CLAIM_OPTIONS_SUCCESS,
        claimantId
      }
    store.dispatch(action)
}


export function getClaimOptionsRequest (){
    return {
        type: GET_CLAIM_OPTIONS_REQUEST
    }
} 



export function getEclaimOptionsPageAction(accessToken, visitDate, companyId, claimaintId, callback) {
    visitDate = visitDate ? 'date=' + visitDate : '';
    let url = `${ROOT_URL}/claims/config/claimoptions/v2?${visitDate}`;
    url += (companyId) ? '&companyId=' + companyId : '';
    url += (claimaintId) ? '&claimantUUID=' + claimaintId : '';
    
    return axios({
        method: 'GET',
        url,
        headers: { 'Accesstoken' : accessToken }
    }).then((response) => {
        callback(response, null);
        console.log('getClaimOptions success', response);
        return {
            type: GET_CLAIM_OPTIONS_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        callback(null, error);
        console.log('getClaimOptions error', error);
        return {
            type: GET_CLAIM_OPTIONS_ERROR,
            payload: error.message
        }
    });
}

export function exportUserList(filtered = null, typeQuery = null, memberType = 'all', accessToken, callback) {

    const url = `${ROOT_URL}/sysadmin/users/downloadlist?${qs.stringify({
        filtered,
        typeQuery,
        memberType
    })}`;
    console.log("check url", url)
    return axios({
        method: 'GET',
        url,
        headers: { 'Accesstoken' : accessToken }, 
    }).then((response) => { 
        callback("SUCCESS", null);
    }).catch((error) => {
        callback(null, error)
        console.log('Download List', error);
    });
}

export function filterClient({ accessToken, searchPage = null, searchMax = null, filtered = null, typeQuery = null }, callback) {
    const url = `${ROOT_URL}/sysadmin/clients/filter?${qs.stringify({
        searchPage,
        searchMax,
        filtered,
        typeQuery
    })}`;
    return axios({
        method: 'GET',
        url,
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        console.log('filterClient', response);
        callback(response, null);
    }).catch((error) => {
        callback(null, error);
        console.log('filterClient error', error);
    })
}

export function getSystemAdminCompanies({ accessToken, searchPage = null, searchMax = null, params = {} }, callback) { 
    const url =`${ROOT_URL}/sysadmin/ms_companies?${qs.stringify({
        searchPage,
        searchMax,
        ...params
    })}`; 
    
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: { 'Accesstoken' : accessToken }
    }).then((response) => {  
        callback(response, null);
        return { 
            type: GET_SYSTEM_ADMIN_COMPANIES_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getSystemAdminCompanies', error);
        callback(null, error);
        return {
            type: GET_SYSTEM_ADMIN_COMPANIES_ERROR,
            payload: error.message
        }
    });
}

export function ssoLogin(tokenId, callback) {
    const url = `${ROOT_URL}/users/ssoLogin`;
    return axios.post(url, {
        tokenId: tokenId
    }).then((response) => {
        callback(response.data, null);
        return {
            type: DO_LOGIN_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log(error);
        callback(null, error);
        return {
            type: DO_LOGIN_ERROR,
            payload: error
        };
    });
}

export function downloadClinicListBySysAdmin(accessToken, companyId, type, nric, callback) {
    let companyIdQuery = `?companyId=${companyId}`;
    let typeQuery = type ? `&type=${type}` : "" ;
    let nricQuery = nric ? `&nric=${nric}` : "" ;

    const url = `${ROOT_URL}/sysadmin/clinics/list${companyIdQuery}${typeQuery}${nricQuery}`;
    
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: { 'Accesstoken' : accessToken },
        responseType: 'blob', 
    }).then((response) => {
        callback("SUCCESS", null);
        console.log('Download List by SysAdmin', response);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Clinic_List.xlsx'); 
        document.body.appendChild(link);
        link.click();
    }).catch((error) => {
        callback(null, error)
        console.log('Download List by SysAdmin', error);
    });
}

export function submitRequestAccountRecovery(data, callback) {
    const url = `${ROOT_URL}/users/requestAccountRecoverySuccess`;
    return axios.post(url, {
        email: data.email,
        captchaResponse: data.robot_id
    }).then((response) => {
        console.log('submitRequestAccountRecovery', response);
        callback(response.status, null);
        return {
            type: SUBMIT_REQ_RESET_PASSWORD_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('submitRequestAccountRecovery', error);
        callback(null, error);
        return {
            type: SUBMIT_REQ_RESET_PASSWORD_ERROR,
            payload: error
        };
    });
}

export function viewUserAction({accessToken, uuid}, callback) {
    const url = `${ROOT_URL}/users/${uuid}`;
    return axios({
        method: 'GET',
        url,
        headers: { 'Accesstoken' : accessToken }
    }).then((response) => {
        if (callback) {
            callback(response.data, null);
        }
        return {
            type: VIEW_USER_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('viewUserAction', error);
        if (callback) {
            callback(null, error);
        }
        return {
            type: VIEW_USER_ERROR,
            payload: error.message
        }
    });
}

export function getVisitsListAction({visitFilterOptions, accessToken, companyId}, callback) {
    const { fromDate, toDate, filterByClaimant, filterByCompany } = visitFilterOptions;
    const convertedFromDate = Moment(fromDate).format('YYYYMMDD');
    const convertedToDate = Moment(toDate).format('YYYYMMDD');
    let uuidQuery = '';
    let companyIdQuery = `&companyId=${companyId}` || null;
    if (filterByClaimant) { uuidQuery = `&uuid=${filterByClaimant}`; }
    if (filterByCompany) { companyIdQuery = `&companyId=${filterByCompany}`; }
    const url = `${ROOT_URL}/visits/v2?from=${convertedFromDate}&to=${convertedToDate}${companyIdQuery}${uuidQuery}`;
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: { 'Accesstoken' : accessToken }
    }).then((response) => {
        console.log('getVisitsListAction', response);
        if (callback) {
            callback(response.data, null);
        }

        return {
            type: VISITS_LIST_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('getVisitsListAction', error);
        if (callback) {
            callback(null, error);
        }
        return {
            type: VISITS_LIST_ERROR,
            payload: error
        }
    });
}

export function getVisitDetailAction({accessToken, visitId}, callback) {
    let url = `${ROOT_URL}/visitDetail/v2`
    url += '/' + visitId;

    console.log(url)
    return axios({
        method: 'GET',
        url,
        data: {},
        headers: {
            'Accesstoken': accessToken
        }
    }).then((response) => {
        if (callback) {
            callback(response.data, null);
        }
        return {
            type: VISITS_DETAILS_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        if (callback) {
            callback(null, error);
        }
        return {
            type: VISITS_DETAILS_ERROR,
            payload: error
        }
    });
}

export function getSettlementLetter(accessToken, nric, policyNo, transactionNo) { 
    return (dispatch, getState) => {
        let urlString = ROOT_URL  + `/claims/settlement/${nric}/${policyNo}/${transactionNo}`;
        return fetch(urlString, {
            method: 'GET',
            headers: {
                'AccessToken': accessToken,
                'Content-Type': 'application/pdf',
            }, 
        }).then(response => {
            if (response.ok) {
                return response.json().then(json => {  
                    return {
                        type: GET_SETTLEMENT_LETTER_SUCCESS,
                        payload: json['data']
                    }
                });
            }
        }).catch(error => {
            return {
                type: GET_SETTLEMENT_LETTER_ERROR,
                payload: error
            }
        });
    };
}

export function submitSystemAdminBatchAdmin(accessToken, file, callback) {
    const url =`${ROOT_URL}/sysadmin/admin/setup/uploadbatch`;
    const formData = new FormData();
    formData.append('file', file);
    return axios({
        method: 'POST',
        url,
        data: formData,
        headers: { 'Accesstoken': accessToken }
    }).then((response) => {
        console.log('submitSystemAdminBatchAdmin', response);
        callback(response.data, null);
        return {
            type: SUBMIT_SYSTEM_ADMIN_CREATE_USER_SUCCESS,
            payload: response
        };
    }).catch((error) => {
        console.log('submitSystemAdminBatchAdmin', error);
        callback(null, error);
        return {
            type: SUBMIT_SYSTEM_ADMIN_CREATE_USER_ERROR,
            payload: error.message
        }
    });
}

export function validateAdminActivation(activationId, callback) {
    const url =`${ROOT_URL}/users/activateLink/check`;
    // let activationId = encryptStringWithPublicKey(_activationId)
    return axios({
        method: 'POST',
        url,
        data: { activationId },
    }).then((response) => {
        console.log('validateAdminActivation', response);
        callback(response.data, null);
    }).catch((error) => {
        console.log('validateAdminActivation', error);
        callback(null, error);
    });
}

export function submiValidateAdminActivation(activationId, _password, callback) {
    const url =`${ROOT_URL}/users/activateLink/validate`;
    let password = encryptStringWithPublicKey(_password)
    return axios({
        method: 'POST',
        url,
        data: { activationId, password },
    }).then((response) => {
        console.log('submiValidateAdminActivation', response);
        callback(response.data, null);
    }).catch((error) => {
        console.log('submiValidateAdminActivation', error);
        callback(null, error);
    });
}

export function getAuthenticatorOTP({ accessToken }, callback) {
    const url = `${ROOT_URL}/member/authenticator/otp`;
    return dispatch => {
        dispatch({ type: GET_AUTHENTICATOR_OTP_REQUEST });
        return axios({
            method: 'GET',
            url,
            headers: { 'Accesstoken': accessToken },
        }).then((response) => {
            console.log('getAuthenticatorOTP', response);
            dispatch({ type: GET_AUTHENTICATOR_OTP_SUCCESS, payload: response });
            if (callback) callback(response.data, null);
        }).catch((error) => {
            console.log('getAuthenticatorOTP', error);
            dispatch({ type: GET_AUTHENTICATOR_OTP_ERROR, payload: error });
            if (callback) callback(null, error);
        });
    };
}

